export const purpleFibreAddresses =
  // staging
  // [
  //   {
  //     BuildingNumber: "27",
  //     Street: "CENTRAL AVE",
  //     City: "Halifax",
  //     Province: "NS",
  //     SA_SFRecordID: "a2VG1000002E9jpMAC",
  //   },

  //   {
  //     BuildingNumber: "118",
  //     Street: "ADELAIDE AVE",
  //     City: "Halifax",
  //     Province: "NS",
  //     SA_SFRecordID: "a2VG1000002E9gbMAC",
  //   },
  // ]

  // production address
  [
    {
      BuildingNumber: "1",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wU52AI",
    },
    {
      BuildingNumber: "1",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xeu2AA",
    },
    {
      BuildingNumber: "1",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77o2AC",
    },
    {
      BuildingNumber: "1",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vy2AK",
    },
    {
      BuildingNumber: "1",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zew2AA",
    },
    {
      BuildingNumber: "1",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqI2AQ",
    },
    {
      BuildingNumber: "1",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrn2AA",
    },
    {
      BuildingNumber: "1",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xlD2AQ",
    },
    {
      BuildingNumber: "10",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ja2AC",
    },
    {
      BuildingNumber: "10",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Et2AK",
    },
    {
      BuildingNumber: "10",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8YR2A0",
    },
    {
      BuildingNumber: "10",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wIx2AI",
    },
    {
      BuildingNumber: "10",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZD2AY",
    },
    {
      BuildingNumber: "10",
      Street: "CROSS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5aa2AC",
    },
    {
      BuildingNumber: "10",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Tb2AK",
    },
    {
      BuildingNumber: "10",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7W12AK",
    },
    {
      BuildingNumber: "10",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A21c2AC",
    },
    {
      BuildingNumber: "10",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u62AC",
    },
    {
      BuildingNumber: "10",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6222AC",
    },
    {
      BuildingNumber: "10",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Bg2AK",
    },
    {
      BuildingNumber: "10",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS92AI",
    },
    {
      BuildingNumber: "10",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qu2AK",
    },
    {
      BuildingNumber: "10",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0pU2AS",
    },
    {
      BuildingNumber: "10",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xAH2AY",
    },
    {
      BuildingNumber: "100",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LO2A0",
    },
    {
      BuildingNumber: "100",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qT2AS",
    },
    {
      BuildingNumber: "100",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HQ2A0",
    },
    {
      BuildingNumber: "100",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G62AK",
    },
    {
      BuildingNumber: "100",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7CZ2A0",
    },
    {
      BuildingNumber: "101",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6V12AK",
    },
    {
      BuildingNumber: "101",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qU2AS",
    },
    {
      BuildingNumber: "101",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zj2AC",
    },
    {
      BuildingNumber: "101",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68U2AS",
    },
    {
      BuildingNumber: "101",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8zp2AC",
    },
    {
      BuildingNumber: "101",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s42AC",
    },
    {
      BuildingNumber: "101",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Bf2AK",
    },
    {
      BuildingNumber: "102",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Dj2AK",
    },
    {
      BuildingNumber: "102",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8v22AC",
    },
    {
      BuildingNumber: "102",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qO2AS",
    },
    {
      BuildingNumber: "102",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5P2AQ",
    },
    {
      BuildingNumber: "103",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5ty2AC",
    },
    {
      BuildingNumber: "103",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vk2AC",
    },
    {
      BuildingNumber: "103",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrS2AQ",
    },
    {
      BuildingNumber: "103",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzr2AA",
    },
    {
      BuildingNumber: "104",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYX2AY",
    },
    {
      BuildingNumber: "104",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8yE2AS",
    },
    {
      BuildingNumber: "104",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn22AA",
    },
    {
      BuildingNumber: "104",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ztS2AQ",
    },
    {
      BuildingNumber: "104",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2bA2AS",
    },
    {
      BuildingNumber: "105",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Bh2AK",
    },
    {
      BuildingNumber: "105",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8IJ2A0",
    },
    {
      BuildingNumber: "105",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A23L2AS",
    },
    {
      BuildingNumber: "105",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kg2AK",
    },
    {
      BuildingNumber: "105",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYV2AY",
    },
    {
      BuildingNumber: "105",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Nj2AK",
    },
    {
      BuildingNumber: "106",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOa2AI",
    },
    {
      BuildingNumber: "106",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6A42AK",
    },
    {
      BuildingNumber: "106",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3cD2AS",
    },
    {
      BuildingNumber: "106",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8lJ2AS",
    },
    {
      BuildingNumber: "107",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8mw2AC",
    },
    {
      BuildingNumber: "107",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LR2A0",
    },
    {
      BuildingNumber: "107",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2gA2AS",
    },
    {
      BuildingNumber: "107",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoT2AQ",
    },
    {
      BuildingNumber: "107",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ze2AC",
    },
    {
      BuildingNumber: "108",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tH2AS",
    },
    {
      BuildingNumber: "108",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6eg2AC",
    },
    {
      BuildingNumber: "108",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A07y2AC",
    },
    {
      BuildingNumber: "108",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kH2AS",
    },
    {
      BuildingNumber: "108",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8rm2AC",
    },
    {
      BuildingNumber: "109",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qS2AS",
    },
    {
      BuildingNumber: "109",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xV72AI",
    },
    {
      BuildingNumber: "109",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xer2AA",
    },
    {
      BuildingNumber: "109",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ed2AK",
    },
    {
      BuildingNumber: "109",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57Y2AS",
    },
    {
      BuildingNumber: "11",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsS2AQ",
    },
    {
      BuildingNumber: "11",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg52AA",
    },
    {
      BuildingNumber: "11",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TL2A0",
    },
    {
      BuildingNumber: "11",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6un2AC",
    },
    {
      BuildingNumber: "11",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xF02AI",
    },
    {
      BuildingNumber: "11",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xZp2AI",
    },
    {
      BuildingNumber: "11",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L52AK",
    },
    {
      BuildingNumber: "11",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bV2AS",
    },
    {
      BuildingNumber: "11",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sT2AS",
    },
    {
      BuildingNumber: "11",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xeq2AA",
    },
    {
      BuildingNumber: "11",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sX2AS",
    },
    {
      BuildingNumber: "11",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4jO2AS",
    },
    {
      BuildingNumber: "11",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2bD2AS",
    },
    {
      BuildingNumber: "110",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Om2AK",
    },
    {
      BuildingNumber: "110",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3XC2A0",
    },
    {
      BuildingNumber: "110",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xr2AK",
    },
    {
      BuildingNumber: "110",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4hl2AC",
    },
    {
      BuildingNumber: "110",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2ZZ2A0",
    },
    {
      BuildingNumber: "111",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kh2AK",
    },
    {
      BuildingNumber: "111",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vi2AC",
    },
    {
      BuildingNumber: "111",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Br2AK",
    },
    {
      BuildingNumber: "111",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yeA2AQ",
    },
    {
      BuildingNumber: "111",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8be2AC",
    },
    {
      BuildingNumber: "112",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUS2AY",
    },
    {
      BuildingNumber: "112",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yit2AA",
    },
    {
      BuildingNumber: "112",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68T2AS",
    },
    {
      BuildingNumber: "112",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ay2AK",
    },
    {
      BuildingNumber: "113",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8jj2AC",
    },
    {
      BuildingNumber: "113",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8rl2AC",
    },
    {
      BuildingNumber: "113",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A91S2AS",
    },
    {
      BuildingNumber: "113",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgP2AQ",
    },
    {
      BuildingNumber: "113",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8S12AK",
    },
    {
      BuildingNumber: "114",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xhw2AA",
    },
    {
      BuildingNumber: "114",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A35q2AC",
    },
    {
      BuildingNumber: "114",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A88d2AC",
    },
    {
      BuildingNumber: "115",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Us2AK",
    },
    {
      BuildingNumber: "115",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tG2AS",
    },
    {
      BuildingNumber: "115",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3XD2A0",
    },
    {
      BuildingNumber: "115",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F52AK",
    },
    {
      BuildingNumber: "116",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jx2AK",
    },
    {
      BuildingNumber: "116",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ul2AK",
    },
    {
      BuildingNumber: "116",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1C72AK",
    },
    {
      BuildingNumber: "116",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gV2AS",
    },
    {
      BuildingNumber: "117",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jw2AK",
    },
    {
      BuildingNumber: "117",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yno2AA",
    },
    {
      BuildingNumber: "117",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysX2AQ",
    },
    {
      BuildingNumber: "117",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zq2AK",
    },
    {
      BuildingNumber: "117",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yW2AS",
    },
    {
      BuildingNumber: "117",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s22AC",
    },
    {
      BuildingNumber: "118",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A99V2AS",
    },
    {
      BuildingNumber: "118",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A24r2AC",
    },
    {
      BuildingNumber: "118",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjk2AA",
    },
    {
      BuildingNumber: "119",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqG2AQ",
    },
    {
      BuildingNumber: "119",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nh2AC",
    },
    {
      BuildingNumber: "119",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tx2AC",
    },
    {
      BuildingNumber: "119",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ml2AC",
    },
    {
      BuildingNumber: "119",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5EA2A0",
    },
    {
      BuildingNumber: "12",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xba2AA",
    },
    {
      BuildingNumber: "12",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8292AC",
    },
    {
      BuildingNumber: "12",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4DH2A0",
    },
    {
      BuildingNumber: "12",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysa2AA",
    },
    {
      BuildingNumber: "12",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TM2A0",
    },
    {
      BuildingNumber: "12",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xex2AA",
    },
    {
      BuildingNumber: "12",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6zd2AC",
    },
    {
      BuildingNumber: "12",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G42AK",
    },
    {
      BuildingNumber: "12",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1NM2A0",
    },
    {
      BuildingNumber: "12",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qx2AK",
    },
    {
      BuildingNumber: "12",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jj2AK",
    },
    {
      BuildingNumber: "12",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4GQ2A0",
    },
    {
      BuildingNumber: "12",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAr2AI",
    },
    {
      BuildingNumber: "12",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2wD2AS",
    },
    {
      BuildingNumber: "120",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrh2AA",
    },
    {
      BuildingNumber: "120",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Es2AK",
    },
    {
      BuildingNumber: "120",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Tu2AK",
    },
    {
      BuildingNumber: "120",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Me2AK",
    },
    {
      BuildingNumber: "121",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eB2AS",
    },
    {
      BuildingNumber: "121",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsW2AQ",
    },
    {
      BuildingNumber: "121",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sU2AS",
    },
    {
      BuildingNumber: "121",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wXU2AY",
    },
    {
      BuildingNumber: "121",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYT2AY",
    },
    {
      BuildingNumber: "121",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Md2AK",
    },
    {
      BuildingNumber: "122",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sU2AS",
    },
    {
      BuildingNumber: "122",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qR2AS",
    },
    {
      BuildingNumber: "122",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6l82AC",
    },
    {
      BuildingNumber: "122",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mf2AK",
    },
    {
      BuildingNumber: "123",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m52AC",
    },
    {
      BuildingNumber: "123",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A94f2AC",
    },
    {
      BuildingNumber: "123",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wdt2AA",
    },
    {
      BuildingNumber: "123",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8uz2AC",
    },
    {
      BuildingNumber: "124",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5U82AK",
    },
    {
      BuildingNumber: "124",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZF2A0",
    },
    {
      BuildingNumber: "124",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A96H2AS",
    },
    {
      BuildingNumber: "124",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1SC2A0",
    },
    {
      BuildingNumber: "125",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Z22AK",
    },
    {
      BuildingNumber: "125",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l32AC",
    },
    {
      BuildingNumber: "125",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fs2AK",
    },
    {
      BuildingNumber: "125",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1dd2AC",
    },
    {
      BuildingNumber: "126",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rp2AK",
    },
    {
      BuildingNumber: "126",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15i2AC",
    },
    {
      BuildingNumber: "126",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8wb2AC",
    },
    {
      BuildingNumber: "127",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gW2AS",
    },
    {
      BuildingNumber: "127",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xmk2AA",
    },
    {
      BuildingNumber: "127",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VC2A0",
    },
    {
      BuildingNumber: "128",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sV2AS",
    },
    {
      BuildingNumber: "128",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9342AC",
    },
    {
      BuildingNumber: "128",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zt2AK",
    },
    {
      BuildingNumber: "128",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yHR2AY",
    },
    {
      BuildingNumber: "129",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4BV2A0",
    },
    {
      BuildingNumber: "129",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjd2AA",
    },
    {
      BuildingNumber: "129",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2pe2AC",
    },
    {
      BuildingNumber: "13",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oM2AS",
    },
    {
      BuildingNumber: "13",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzS2AQ",
    },
    {
      BuildingNumber: "13",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6py2AC",
    },
    {
      BuildingNumber: "13",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xtA2AQ",
    },
    {
      BuildingNumber: "13",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg32AA",
    },
    {
      BuildingNumber: "13",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A13w2AC",
    },
    {
      BuildingNumber: "13",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGo2AI",
    },
    {
      BuildingNumber: "13",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A34G2AS",
    },
    {
      BuildingNumber: "13",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8q92AC",
    },
    {
      BuildingNumber: "13",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2xl2AC",
    },
    {
      BuildingNumber: "13",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9pS2AS",
    },
    {
      BuildingNumber: "13",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41y2AC",
    },
    {
      BuildingNumber: "13",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsP2AQ",
    },
    {
      BuildingNumber: "13",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ia2AC",
    },
    {
      BuildingNumber: "130",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZG2A0",
    },
    {
      BuildingNumber: "130",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5L2AQ",
    },
    {
      BuildingNumber: "131",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yuE2AQ",
    },
    {
      BuildingNumber: "131",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rn2AK",
    },
    {
      BuildingNumber: "132",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rq2AK",
    },
    {
      BuildingNumber: "132",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hD2AS",
    },
    {
      BuildingNumber: "132",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3iZ2AS",
    },
    {
      BuildingNumber: "133",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Tv2AK",
    },
    {
      BuildingNumber: "133",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ur2AK",
    },
    {
      BuildingNumber: "133",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9352AC",
    },
    {
      BuildingNumber: "134",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8qB2AS",
    },
    {
      BuildingNumber: "134",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9332AC",
    },
    {
      BuildingNumber: "134",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q62AK",
    },
    {
      BuildingNumber: "135",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wM92AI",
    },
    {
      BuildingNumber: "135",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3FP2A0",
    },
    {
      BuildingNumber: "136",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yiy2AA",
    },
    {
      BuildingNumber: "136",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PF2A0",
    },
    {
      BuildingNumber: "136",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yuC2AQ",
    },
    {
      BuildingNumber: "137",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8zq2AC",
    },
    {
      BuildingNumber: "138",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrT2AQ",
    },
    {
      BuildingNumber: "138",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWg2AI",
    },
    {
      BuildingNumber: "139",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A55z2AC",
    },
    {
      BuildingNumber: "139",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYR2AY",
    },
    {
      BuildingNumber: "14",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0pT2AS",
    },
    {
      BuildingNumber: "14",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72t2AC",
    },
    {
      BuildingNumber: "14",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Xh2AK",
    },
    {
      BuildingNumber: "14",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mg2AC",
    },
    {
      BuildingNumber: "14",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYO2AY",
    },
    {
      BuildingNumber: "14",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rr2AK",
    },
    {
      BuildingNumber: "14",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w4U2AQ",
    },
    {
      BuildingNumber: "14",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A13v2AC",
    },
    {
      BuildingNumber: "14",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kK2AS",
    },
    {
      BuildingNumber: "14",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rl2AK",
    },
    {
      BuildingNumber: "14",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wlu2AA",
    },
    {
      BuildingNumber: "14",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3tl2AC",
    },
    {
      BuildingNumber: "14",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KZ2A0",
    },
    {
      BuildingNumber: "140",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A96I2AS",
    },
    {
      BuildingNumber: "140",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnS2AQ",
    },
    {
      BuildingNumber: "141",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8es2AC",
    },
    {
      BuildingNumber: "143",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AE2A0",
    },
    {
      BuildingNumber: "144",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zyC2AQ",
    },
    {
      BuildingNumber: "144",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zLa2AI",
    },
    {
      BuildingNumber: "145",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8v02AC",
    },
    {
      BuildingNumber: "145",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15h2AC",
    },
    {
      BuildingNumber: "145",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yaq2AA",
    },
    {
      BuildingNumber: "146",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYW2AY",
    },
    {
      BuildingNumber: "146",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YG2A0",
    },
    {
      BuildingNumber: "147",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A13x2AC",
    },
    {
      BuildingNumber: "147",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDN2AY",
    },
    {
      BuildingNumber: "148",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xep2AA",
    },
    {
      BuildingNumber: "148",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ol2AK",
    },
    {
      BuildingNumber: "149",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xTW2AY",
    },
    {
      BuildingNumber: "149",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8a22AC",
    },
    {
      BuildingNumber: "149",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hE2AS",
    },
    {
      BuildingNumber: "15",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xlC2AQ",
    },
    {
      BuildingNumber: "15",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6232AC",
    },
    {
      BuildingNumber: "15",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kF2AS",
    },
    {
      BuildingNumber: "15",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sM2AS",
    },
    {
      BuildingNumber: "15",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6N02AK",
    },
    {
      BuildingNumber: "15",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6212AC",
    },
    {
      BuildingNumber: "15",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kH2AS",
    },
    {
      BuildingNumber: "15",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlJ2AQ",
    },
    {
      BuildingNumber: "15",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7yv2AC",
    },
    {
      BuildingNumber: "15",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2BN2A0",
    },
    {
      BuildingNumber: "15",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yHQ2AY",
    },
    {
      BuildingNumber: "15",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8Z2AQ",
    },
    {
      BuildingNumber: "15",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6My2AK",
    },
    {
      BuildingNumber: "15",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tz2AC",
    },
    {
      BuildingNumber: "15",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysV2AQ",
    },
    {
      BuildingNumber: "15",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u52AC",
    },
    {
      BuildingNumber: "15",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6N42AK",
    },
    {
      BuildingNumber: "150",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5K2AQ",
    },
    {
      BuildingNumber: "151",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A97u2AC",
    },
    {
      BuildingNumber: "151",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8i62AC",
    },
    {
      BuildingNumber: "152",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A35p2AC",
    },
    {
      BuildingNumber: "152",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VD2A0",
    },
    {
      BuildingNumber: "153",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8et2AC",
    },
    {
      BuildingNumber: "153",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dG2AS",
    },
    {
      BuildingNumber: "154",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5I2AQ",
    },
    {
      BuildingNumber: "155",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A97t2AC",
    },
    {
      BuildingNumber: "156",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sj2AK",
    },
    {
      BuildingNumber: "157",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zyD2AQ",
    },
    {
      BuildingNumber: "16",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9e92AC",
    },
    {
      BuildingNumber: "16",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KW2A0",
    },
    {
      BuildingNumber: "16",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tQ2AS",
    },
    {
      BuildingNumber: "16",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oE2AS",
    },
    {
      BuildingNumber: "16",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A34F2AS",
    },
    {
      BuildingNumber: "16",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuo2AA",
    },
    {
      BuildingNumber: "16",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mj2AK",
    },
    {
      BuildingNumber: "16",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bZ2AS",
    },
    {
      BuildingNumber: "16",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8NB2A0",
    },
    {
      BuildingNumber: "16",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ox2AC",
    },
    {
      BuildingNumber: "16",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8oX2AS",
    },
    {
      BuildingNumber: "16",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5SV2A0",
    },
    {
      BuildingNumber: "16",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3sD2AS",
    },
    {
      BuildingNumber: "16",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1jw2AC",
    },
    {
      BuildingNumber: "16",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TG2A0",
    },
    {
      BuildingNumber: "16",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzW2AQ",
    },
    {
      BuildingNumber: "160",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jm2AK",
    },
    {
      BuildingNumber: "160",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A07z2AC",
    },
    {
      BuildingNumber: "161",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vz2AK",
    },
    {
      BuildingNumber: "164",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bV2AS",
    },
    {
      BuildingNumber: "165",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9B72AK",
    },
    {
      BuildingNumber: "166",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xt92AA",
    },
    {
      BuildingNumber: "167",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yXd2AI",
    },
    {
      BuildingNumber: "168",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jn2AK",
    },
    {
      BuildingNumber: "168",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G72AK",
    },
    {
      BuildingNumber: "169",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Wo2AK",
    },
    {
      BuildingNumber: "17",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u82AC",
    },
    {
      BuildingNumber: "17",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjh2AA",
    },
    {
      BuildingNumber: "17",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5182AC",
    },
    {
      BuildingNumber: "17",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4En2AK",
    },
    {
      BuildingNumber: "17",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrr2AA",
    },
    {
      BuildingNumber: "17",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1df2AC",
    },
    {
      BuildingNumber: "17",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xZq2AI",
    },
    {
      BuildingNumber: "17",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2o72AC",
    },
    {
      BuildingNumber: "17",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fb2AC",
    },
    {
      BuildingNumber: "17",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5632AC",
    },
    {
      BuildingNumber: "17",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8a2AA",
    },
    {
      BuildingNumber: "17",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wIw2AI",
    },
    {
      BuildingNumber: "17",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6rZ2AS",
    },
    {
      BuildingNumber: "17",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vv2AK",
    },
    {
      BuildingNumber: "17",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4DI2A0",
    },
    {
      BuildingNumber: "172",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R52AK",
    },
    {
      BuildingNumber: "172",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8qA2AS",
    },
    {
      BuildingNumber: "173",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TE2A0",
    },
    {
      BuildingNumber: "176",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5J2AQ",
    },
    {
      BuildingNumber: "177",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4wK2AS",
    },
    {
      BuildingNumber: "177",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8bf2AC",
    },
    {
      BuildingNumber: "178",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vl2AK",
    },
    {
      BuildingNumber: "179",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0EN2A0",
    },
    {
      BuildingNumber: "179",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yvi2AA",
    },
    {
      BuildingNumber: "18",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQQ2AY",
    },
    {
      BuildingNumber: "18",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3dd2AC",
    },
    {
      BuildingNumber: "18",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6zg2AC",
    },
    {
      BuildingNumber: "18",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za42AA",
    },
    {
      BuildingNumber: "18",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgJ2AQ",
    },
    {
      BuildingNumber: "18",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gD2AS",
    },
    {
      BuildingNumber: "18",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Pe2AK",
    },
    {
      BuildingNumber: "18",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6N32AK",
    },
    {
      BuildingNumber: "18",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A99W2AS",
    },
    {
      BuildingNumber: "18",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1da2AC",
    },
    {
      BuildingNumber: "18",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8S22AK",
    },
    {
      BuildingNumber: "18",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1CA2A0",
    },
    {
      BuildingNumber: "180",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vum2AA",
    },
    {
      BuildingNumber: "180",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ra2AK",
    },
    {
      BuildingNumber: "181",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6px2AC",
    },
    {
      BuildingNumber: "181",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sk2AK",
    },
    {
      BuildingNumber: "182",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysY2AQ",
    },
    {
      BuildingNumber: "183",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A61y2AC",
    },
    {
      BuildingNumber: "184",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xzr2AA",
    },

    {
      BuildingNumber: "185",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zY2AS",
    },
    {
      BuildingNumber: "185",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vj2AC",
    },
    {
      BuildingNumber: "187",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xA2AS",
    },
    {
      BuildingNumber: "188",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A88b2AC",
    },
    {
      BuildingNumber: "188",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ze2AC",
    },
    {
      BuildingNumber: "189",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5x92AC",
    },
    {
      BuildingNumber: "189",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDM2AY",
    },
    {
      BuildingNumber: "19",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lr2AC",
    },
    {
      BuildingNumber: "19",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5nT2AS",
    },
    {
      BuildingNumber: "19",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65E2AS",
    },
    {
      BuildingNumber: "19",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UX2A0",
    },
    {
      BuildingNumber: "19",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xF2AS",
    },
    {
      BuildingNumber: "19",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63c2AC",
    },
    {
      BuildingNumber: "19",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Ym2AK",
    },
    {
      BuildingNumber: "19",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ep2AK",
    },
    {
      BuildingNumber: "19",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Pi2AK",
    },
    {
      BuildingNumber: "19",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5aY2AS",
    },
    {
      BuildingNumber: "19",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sT2AS",
    },
    {
      BuildingNumber: "19",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZU2A0",
    },
    {
      BuildingNumber: "190",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72u2AC",
    },
    {
      BuildingNumber: "190",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Rb2AK",
    },
    {
      BuildingNumber: "191",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3VZ2A0",
    },
    {
      BuildingNumber: "192",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60O2AS",
    },
    {
      BuildingNumber: "192",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MH2A0",
    },
    {
      BuildingNumber: "193",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rq2AK",
    },
    {
      BuildingNumber: "194",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E52AK",
    },
    {
      BuildingNumber: "196",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zi62AA",
    },
    {
      BuildingNumber: "196",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS82AI",
    },
    {
      BuildingNumber: "197",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5SX2A0",
    },
    {
      BuildingNumber: "197",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LM2A0",
    },
    {
      BuildingNumber: "197",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnT2AQ",
    },
    {
      BuildingNumber: "198",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UV2A0",
    },
    {
      BuildingNumber: "199",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4kz2AC",
    },
    {
      BuildingNumber: "2",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5yk2AC",
    },
    {
      BuildingNumber: "2",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xtB2AQ",
    },
    {
      BuildingNumber: "2",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MI2A0",
    },
    {
      BuildingNumber: "2",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yas2AA",
    },
    {
      BuildingNumber: "2",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vc2AK",
    },
    {
      BuildingNumber: "2",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Er2AK",
    },
    {
      BuildingNumber: "2",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrP2AQ",
    },
    {
      BuildingNumber: "20",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YH2A0",
    },
    {
      BuildingNumber: "20",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6up2AC",
    },
    {
      BuildingNumber: "20",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nj2AC",
    },
    {
      BuildingNumber: "20",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ck2AK",
    },
    {
      BuildingNumber: "20",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xTX2AY",
    },
    {
      BuildingNumber: "20",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5622AC",
    },
    {
      BuildingNumber: "20",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qy2AK",
    },
    {
      BuildingNumber: "20",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rT2AS",
    },
    {
      BuildingNumber: "20",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Nq2AK",
    },
    {
      BuildingNumber: "20",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nM2AS",
    },
    {
      BuildingNumber: "20",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zO2AS",
    },
    {
      BuildingNumber: "20",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TJ2A0",
    },
    {
      BuildingNumber: "20",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7XX2A0",
    },
    {
      BuildingNumber: "200",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A21b2AC",
    },
    {
      BuildingNumber: "200",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sS2AS",
    },
    {
      BuildingNumber: "201",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77h2AC",
    },
    {
      BuildingNumber: "201",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68R2AS",
    },
    {
      BuildingNumber: "202",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vk2AK",
    },
    {
      BuildingNumber: "203",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOX2AY",
    },
    {
      BuildingNumber: "204",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xja2AA",
    },
    {
      BuildingNumber: "205",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0nu2AC",
    },
    {
      BuildingNumber: "206",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ov2AC",
    },
    {
      BuildingNumber: "206",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lv2AC",
    },
    {
      BuildingNumber: "207",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mb2AK",
    },
    {
      BuildingNumber: "207",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83l2AC",
    },
    {
      BuildingNumber: "208",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y32AC",
    },
    {
      BuildingNumber: "208",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60S2AS",
    },
    {
      BuildingNumber: "209",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5H2AQ",
    },
    {
      BuildingNumber: "21",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg22AA",
    },
    {
      BuildingNumber: "21",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gj2AK",
    },
    {
      BuildingNumber: "21",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kG2AS",
    },
    {
      BuildingNumber: "21",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9fl2AC",
    },
    {
      BuildingNumber: "21",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrO2AQ",
    },
    {
      BuildingNumber: "21",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7dy2AC",
    },
    {
      BuildingNumber: "21",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0uN2AS",
    },
    {
      BuildingNumber: "21",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ42AI",
    },
    {
      BuildingNumber: "21",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yar2AA",
    },
    {
      BuildingNumber: "21",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3tk2AC",
    },
    {
      BuildingNumber: "21",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vW2AS",
    },
    {
      BuildingNumber: "21",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AG2A0",
    },
    {
      BuildingNumber: "210",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Yn2AK",
    },
    {
      BuildingNumber: "210",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQT2AY",
    },
    {
      BuildingNumber: "211A",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E82AK",
    },
    {
      BuildingNumber: "214",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gh2AK",
    },
    {
      BuildingNumber: "215",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Be2AK",
    },
    {
      BuildingNumber: "216",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8jh2AC",
    },
    {
      BuildingNumber: "219",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l12AC",
    },
    {
      BuildingNumber: "22",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y42AC",
    },
    {
      BuildingNumber: "22",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ZJ2A0",
    },
    {
      BuildingNumber: "22",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6I62AK",
    },
    {
      BuildingNumber: "22",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrq2AA",
    },
    {
      BuildingNumber: "22",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tC2AS",
    },
    {
      BuildingNumber: "22",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1lU2AS",
    },
    {
      BuildingNumber: "22",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x6o2AA",
    },
    {
      BuildingNumber: "22",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7cN2AS",
    },
    {
      BuildingNumber: "22",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bQ2AS",
    },
    {
      BuildingNumber: "22",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7PR2A0",
    },
    {
      BuildingNumber: "22",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l52AC",
    },
    {
      BuildingNumber: "220",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5G2AQ",
    },
    {
      BuildingNumber: "223",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8i52AC",
    },
    {
      BuildingNumber: "224",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lu2AC",
    },
    {
      BuildingNumber: "227",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4eg2AC",
    },
    {
      BuildingNumber: "228",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8YQ2A0",
    },
    {
      BuildingNumber: "23",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hR2AS",
    },
    {
      BuildingNumber: "23",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7cL2AS",
    },
    {
      BuildingNumber: "23",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5672AC",
    },
    {
      BuildingNumber: "23",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5du2AC",
    },
    {
      BuildingNumber: "23",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xmo2AA",
    },
    {
      BuildingNumber: "23",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3li2AC",
    },
    {
      BuildingNumber: "23",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlK2AQ",
    },
    {
      BuildingNumber: "23",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A86z2AC",
    },
    {
      BuildingNumber: "23",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5662AC",
    },
    {
      BuildingNumber: "23",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0uM2AS",
    },
    {
      BuildingNumber: "23",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GA2A0",
    },
    {
      BuildingNumber: "231",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDL2AY",
    },
    {
      BuildingNumber: "232",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xM2AS",
    },
    {
      BuildingNumber: "235",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y4S2AQ",
    },
    {
      BuildingNumber: "236",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TS2A0",
    },
    {
      BuildingNumber: "239",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wkQ2AQ",
    },
    {
      BuildingNumber: "24",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nk2AC",
    },
    {
      BuildingNumber: "24",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9av2AC",
    },
    {
      BuildingNumber: "24",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySl2AI",
    },
    {
      BuildingNumber: "24",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xwO2AQ",
    },
    {
      BuildingNumber: "24",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sy2AK",
    },
    {
      BuildingNumber: "24",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za12AA",
    },
    {
      BuildingNumber: "24",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77p2AC",
    },
    {
      BuildingNumber: "24",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A18o2AC",
    },
    {
      BuildingNumber: "24",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xey2AA",
    },
    {
      BuildingNumber: "24",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A09U2AS",
    },
    {
      BuildingNumber: "24",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3FR2A0",
    },
    {
      BuildingNumber: "240",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2eS2AS",
    },
    {
      BuildingNumber: "241",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuk2AA",
    },
    {
      BuildingNumber: "243",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zdF2AQ",
    },
    {
      BuildingNumber: "244",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5PJ2A0",
    },
    {
      BuildingNumber: "247",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5T2AQ",
    },
    {
      BuildingNumber: "248",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzq2AA",
    },
    {
      BuildingNumber: "25",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Gz2AK",
    },
    {
      BuildingNumber: "25",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oH2AS",
    },
    {
      BuildingNumber: "25",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDy2AI",
    },
    {
      BuildingNumber: "25",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xE2AS",
    },
    {
      BuildingNumber: "25",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Wd2AK",
    },
    {
      BuildingNumber: "25",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8Y2AQ",
    },
    {
      BuildingNumber: "25",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4md2AC",
    },
    {
      BuildingNumber: "25",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nN2AS",
    },
    {
      BuildingNumber: "25",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1IW2A0",
    },
    {
      BuildingNumber: "25",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fn2AK",
    },
    {
      BuildingNumber: "250",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8S02AK",
    },
    {
      BuildingNumber: "251",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZC2A0",
    },
    {
      BuildingNumber: "252",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vpl2AA",
    },
    {
      BuildingNumber: "26",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjb2AA",
    },
    {
      BuildingNumber: "26",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEx2AI",
    },
    {
      BuildingNumber: "26",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A82A2AS",
    },
    {
      BuildingNumber: "26",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A48K2AS",
    },
    {
      BuildingNumber: "26",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y32AC",
    },
    {
      BuildingNumber: "26",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1CB2A0",
    },
    {
      BuildingNumber: "26",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wtz2AA",
    },
    {
      BuildingNumber: "26",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CI2A0",
    },
    {
      BuildingNumber: "26",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d52AC",
    },
    {
      BuildingNumber: "26",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqF2AQ",
    },
    {
      BuildingNumber: "26",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Yp2AK",
    },
    {
      BuildingNumber: "26",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cu2AK",
    },
    {
      BuildingNumber: "26",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgK2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80X2AS",
    },
    {
      BuildingNumber: "27",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wu12AA",
    },
    {
      BuildingNumber: "27",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8M2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za62AA",
    },
    {
      BuildingNumber: "27",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqE2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zLZ2AY",
    },
    {
      BuildingNumber: "27",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnU2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LL2A0",
    },
    {
      BuildingNumber: "27",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jX2AS",
    },
    {
      BuildingNumber: "27",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TN2A0",
    },
    {
      BuildingNumber: "28",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57b2AC",
    },
    {
      BuildingNumber: "28",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tE2AS",
    },
    {
      BuildingNumber: "28",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jZ2AS",
    },
    {
      BuildingNumber: "28",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mr2AK",
    },
    {
      BuildingNumber: "28",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MR2A0",
    },
    {
      BuildingNumber: "28",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6pz2AC",
    },
    {
      BuildingNumber: "28",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4d02AC",
    },
    {
      BuildingNumber: "28",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgM2AQ",
    },
    {
      BuildingNumber: "28",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5F2AQ",
    },
    {
      BuildingNumber: "28",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9uH2AS",
    },
    {
      BuildingNumber: "28",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Kn2AK",
    },
    {
      BuildingNumber: "29",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1NO2A0",
    },
    {
      BuildingNumber: "29",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hG2AS",
    },
    {
      BuildingNumber: "29",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgL2AQ",
    },
    {
      BuildingNumber: "29",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1NN2A0",
    },
    {
      BuildingNumber: "29",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysZ2AQ",
    },
    {
      BuildingNumber: "29",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nL2AS",
    },
    {
      BuildingNumber: "29",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65F2AS",
    },
    {
      BuildingNumber: "29",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZV2A0",
    },
    {
      BuildingNumber: "3",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sN2AS",
    },
    {
      BuildingNumber: "3",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xzp2AA",
    },
    {
      BuildingNumber: "3",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8oY2AS",
    },
    {
      BuildingNumber: "3",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0pW2AS",
    },
    {
      BuildingNumber: "3",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sR2AS",
    },
    {
      BuildingNumber: "3",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEw2AI",
    },
    {
      BuildingNumber: "3",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A23K2AS",
    },
    {
      BuildingNumber: "3",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ztR2AQ",
    },
    {
      BuildingNumber: "3",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tN2AS",
    },
    {
      BuildingNumber: "3",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MF2A0",
    },
    {
      BuildingNumber: "3",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8lK2AS",
    },
    {
      BuildingNumber: "3",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Zd2AK",
    },
    {
      BuildingNumber: "3",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5id2AC",
    },
    {
      BuildingNumber: "3",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zyE2AQ",
    },
    {
      BuildingNumber: "3",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3KN2A0",
    },
    {
      BuildingNumber: "30",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjQ2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KV2A0",
    },
    {
      BuildingNumber: "30",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5V2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9cX2AS",
    },
    {
      BuildingNumber: "30",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GY2A0",
    },
    {
      BuildingNumber: "30",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZH2AY",
    },
    {
      BuildingNumber: "30",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TP2A0",
    },
    {
      BuildingNumber: "30",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPR2AY",
    },
    {
      BuildingNumber: "30",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsQ2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kL2AS",
    },
    {
      BuildingNumber: "30",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ZL2A0",
    },
    {
      BuildingNumber: "30",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32h2AC",
    },
    {
      BuildingNumber: "30",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3tm2AC",
    },
    {
      BuildingNumber: "30",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d92AC",
    },
    {
      BuildingNumber: "31",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bR2AS",
    },
    {
      BuildingNumber: "31",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9JB2A0",
    },
    {
      BuildingNumber: "31",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eo2AK",
    },
    {
      BuildingNumber: "31",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ns2AK",
    },
    {
      BuildingNumber: "31",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yR92AI",
    },
    {
      BuildingNumber: "31",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q72AK",
    },
    {
      BuildingNumber: "31",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63b2AC",
    },
    {
      BuildingNumber: "31",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3oy2AC",
    },
    {
      BuildingNumber: "32",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L32AK",
    },
    {
      BuildingNumber: "32",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS62AI",
    },
    {
      BuildingNumber: "32",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y62AC",
    },
    {
      BuildingNumber: "32",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0362AC",
    },
    {
      BuildingNumber: "32",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57a2AC",
    },
    {
      BuildingNumber: "32",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zk2AC",
    },
    {
      BuildingNumber: "32",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PK2A0",
    },
    {
      BuildingNumber: "32",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vh2AC",
    },
    {
      BuildingNumber: "32",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zs2AK",
    },
    {
      BuildingNumber: "32",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fo2AK",
    },
    {
      BuildingNumber: "32",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dL2AS",
    },
    {
      BuildingNumber: "32",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A96J2AS",
    },
    {
      BuildingNumber: "32",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E42AK",
    },
    {
      BuildingNumber: "3291",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jy2AK",
    },
    {
      BuildingNumber: "3297",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vY2AS",
    },
    {
      BuildingNumber: "33",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDz2AI",
    },
    {
      BuildingNumber: "33",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CJ2A0",
    },
    {
      BuildingNumber: "33",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjf2AA",
    },
    {
      BuildingNumber: "33",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrW2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQS2AY",
    },
    {
      BuildingNumber: "33",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqD2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Lu2AK",
    },
    {
      BuildingNumber: "33",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eC2AS",
    },
    {
      BuildingNumber: "33",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ph2AK",
    },
    {
      BuildingNumber: "33",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zdE2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yR72AI",
    },
    {
      BuildingNumber: "3303",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zIO2AY",
    },
    {
      BuildingNumber: "3316",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgQ2AQ",
    },
    {
      BuildingNumber: "3318",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAp2AI",
    },
    {
      BuildingNumber: "34",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySk2AI",
    },
    {
      BuildingNumber: "34",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65G2AS",
    },
    {
      BuildingNumber: "34",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Ng2AK",
    },
    {
      BuildingNumber: "34",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4hm2AC",
    },
    {
      BuildingNumber: "34",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5N2AQ",
    },
    {
      BuildingNumber: "34",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4t32AC",
    },
    {
      BuildingNumber: "34",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7qu2AC",
    },
    {
      BuildingNumber: "34",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wab2AA",
    },
    {
      BuildingNumber: "34",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w7f2AA",
    },
    {
      BuildingNumber: "34",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yh2AK",
    },
    {
      BuildingNumber: "34",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ca2AC",
    },
    {
      BuildingNumber: "34",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xq2AK",
    },
    {
      BuildingNumber: "34",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzV2AQ",
    },
    {
      BuildingNumber: "3422",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32k2AC",
    },
    {
      BuildingNumber: "3426",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0802AC",
    },
    {
      BuildingNumber: "3450",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F62AK",
    },
    {
      BuildingNumber: "35",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72v2AC",
    },
    {
      BuildingNumber: "35",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kT2AS",
    },
    {
      BuildingNumber: "35",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TC2A0",
    },
    {
      BuildingNumber: "35",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0MQ2A0",
    },
    {
      BuildingNumber: "35",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oP2AS",
    },
    {
      BuildingNumber: "35",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6wQ2AS",
    },
    {
      BuildingNumber: "35",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Fx2AK",
    },
    {
      BuildingNumber: "35",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vu2AK",
    },
    {
      BuildingNumber: "36",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6A62AK",
    },
    {
      BuildingNumber: "36",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R42AK",
    },
    {
      BuildingNumber: "36",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eu2AK",
    },
    {
      BuildingNumber: "36",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y42AC",
    },
    {
      BuildingNumber: "36",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p92AC",
    },
    {
      BuildingNumber: "36",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A24s2AC",
    },
    {
      BuildingNumber: "36",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y62AC",
    },
    {
      BuildingNumber: "36",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mi2AC",
    },
    {
      BuildingNumber: "36",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vX2AS",
    },
    {
      BuildingNumber: "36",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85N2AS",
    },
    {
      BuildingNumber: "36",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74T2AS",
    },
    {
      BuildingNumber: "36",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDK2AY",
    },
    {
      BuildingNumber: "36",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ow2AC",
    },
    {
      BuildingNumber: "36",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PJ2A0",
    },
    {
      BuildingNumber: "37",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqw2AA",
    },
    {
      BuildingNumber: "37",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWk2AI",
    },
    {
      BuildingNumber: "37",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8V2AQ",
    },
    {
      BuildingNumber: "37",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bT2AS",
    },
    {
      BuildingNumber: "37",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77n2AC",
    },
    {
      BuildingNumber: "37",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A49z2AC",
    },
    {
      BuildingNumber: "37",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ki2AK",
    },
    {
      BuildingNumber: "37",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oO2AS",
    },
    {
      BuildingNumber: "37",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAm2AI",
    },
    {
      BuildingNumber: "3722",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xF22AI",
    },
    {
      BuildingNumber: "38",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xre2AA",
    },
    {
      BuildingNumber: "38",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUO2AY",
    },
    {
      BuildingNumber: "38",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72z2AC",
    },
    {
      BuildingNumber: "38",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjl2AA",
    },
    {
      BuildingNumber: "38",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlN2AQ",
    },
    {
      BuildingNumber: "38",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7692AC",
    },
    {
      BuildingNumber: "38",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tD2AS",
    },
    {
      BuildingNumber: "38",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xK2AS",
    },
    {
      BuildingNumber: "38",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A76A2AS",
    },
    {
      BuildingNumber: "38",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eD2AS",
    },
    {
      BuildingNumber: "38",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bS2AS",
    },
    {
      BuildingNumber: "38",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fd2AC",
    },
    {
      BuildingNumber: "39",
      Street: "ASHDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A26V2AS",
    },
    {
      BuildingNumber: "39",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ki2AC",
    },
    {
      BuildingNumber: "39",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rU2AS",
    },
    {
      BuildingNumber: "39",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cw2AK",
    },
    {
      BuildingNumber: "39",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuj2AA",
    },
    {
      BuildingNumber: "39",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wlt2AA",
    },
    {
      BuildingNumber: "39",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yMD2AY",
    },
    {
      BuildingNumber: "39",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hF2AS",
    },
    {
      BuildingNumber: "39",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vm2AK",
    },
    {
      BuildingNumber: "4",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gk2AK",
    },
    {
      BuildingNumber: "4",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9St2AK",
    },
    {
      BuildingNumber: "4",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9B82AK",
    },
    {
      BuildingNumber: "4",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yMF2AY",
    },
    {
      BuildingNumber: "4",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p82AC",
    },
    {
      BuildingNumber: "4",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nn2AC",
    },
    {
      BuildingNumber: "4",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAn2AI",
    },
    {
      BuildingNumber: "4",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yeB2AQ",
    },
    {
      BuildingNumber: "40",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40L2AS",
    },
    {
      BuildingNumber: "40",
      Street: "ASHDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjP2AQ",
    },
    {
      BuildingNumber: "40",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q82AK",
    },
    {
      BuildingNumber: "40",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kE2AS",
    },
    {
      BuildingNumber: "40",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y7l2AA",
    },
    {
      BuildingNumber: "40",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9O32AK",
    },
    {
      BuildingNumber: "40",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GB2A0",
    },
    {
      BuildingNumber: "41",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74V2AS",
    },
    {
      BuildingNumber: "41",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2o82AC",
    },
    {
      BuildingNumber: "41",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xhu2AA",
    },
    {
      BuildingNumber: "41",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7aj2AC",
    },
    {
      BuildingNumber: "41",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TK2A0",
    },
    {
      BuildingNumber: "41",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrf2AA",
    },
    {
      BuildingNumber: "41",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYZ2AY",
    },
    {
      BuildingNumber: "41",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Dl2AK",
    },
    {
      BuildingNumber: "41",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3FQ2A0",
    },
    {
      BuildingNumber: "41",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzT2AQ",
    },
    {
      BuildingNumber: "42",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UW2A0",
    },
    {
      BuildingNumber: "42",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L62AK",
    },
    {
      BuildingNumber: "42",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AH2A0",
    },
    {
      BuildingNumber: "42",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y7k2AA",
    },
    {
      BuildingNumber: "42",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4572AC",
    },
    {
      BuildingNumber: "42",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bY2AS",
    },
    {
      BuildingNumber: "42",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GZ2A0",
    },
    {
      BuildingNumber: "42",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1iN2AS",
    },
    {
      BuildingNumber: "42",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ne2AC",
    },
    {
      BuildingNumber: "43",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUP2AY",
    },
    {
      BuildingNumber: "43",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ej2AC",
    },
    {
      BuildingNumber: "43",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RW2A0",
    },
    {
      BuildingNumber: "43",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6hw2AC",
    },
    {
      BuildingNumber: "43",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EM2A0",
    },
    {
      BuildingNumber: "43",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EL2A0",
    },
    {
      BuildingNumber: "43",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yU2AS",
    },
    {
      BuildingNumber: "44",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77k2AC",
    },
    {
      BuildingNumber: "44",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Di2AK",
    },
    {
      BuildingNumber: "44",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAq2AI",
    },
    {
      BuildingNumber: "44",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ut2AK",
    },
    {
      BuildingNumber: "44",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0mK2AS",
    },
    {
      BuildingNumber: "44",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oN2AS",
    },
    {
      BuildingNumber: "44",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jz2AK",
    },
    {
      BuildingNumber: "44",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fe2AC",
    },
    {
      BuildingNumber: "44",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WT2A0",
    },
    {
      BuildingNumber: "45",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Ro2AK",
    },
    {
      BuildingNumber: "45",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MJ2A0",
    },
    {
      BuildingNumber: "45",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qe2AC",
    },
    {
      BuildingNumber: "45",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Lt2AK",
    },
    {
      BuildingNumber: "45",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWj2AI",
    },
    {
      BuildingNumber: "45",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8eu2AC",
    },
    {
      BuildingNumber: "46",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A35r2AC",
    },
    {
      BuildingNumber: "46",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MP2A0",
    },
    {
      BuildingNumber: "46",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u72AC",
    },
    {
      BuildingNumber: "46",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xAE2AY",
    },
    {
      BuildingNumber: "46",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m72AC",
    },
    {
      BuildingNumber: "46",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6dA2AS",
    },
    {
      BuildingNumber: "46",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32i2AC",
    },
    {
      BuildingNumber: "46",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqx2AA",
    },
    {
      BuildingNumber: "47",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tP2AS",
    },
    {
      BuildingNumber: "47",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YE2A0",
    },
    {
      BuildingNumber: "47",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kQ2AS",
    },
    {
      BuildingNumber: "47",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TT2A0",
    },
    {
      BuildingNumber: "48",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xbZ2AQ",
    },
    {
      BuildingNumber: "48",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32j2AC",
    },
    {
      BuildingNumber: "48",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6zh2AC",
    },
    {
      BuildingNumber: "48",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kG2AS",
    },
    {
      BuildingNumber: "48",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GC2A0",
    },
    {
      BuildingNumber: "48",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrU2AQ",
    },
    {
      BuildingNumber: "49",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye72AA",
    },
    {
      BuildingNumber: "49",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kJ2AS",
    },
    {
      BuildingNumber: "49",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zev2AA",
    },
    {
      BuildingNumber: "5",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yHT2AY",
    },
    {
      BuildingNumber: "5",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y52AK",
    },
    {
      BuildingNumber: "5",
      Street: "BOND ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9sf2AC",
    },
    {
      BuildingNumber: "5",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mf2AC",
    },
    {
      BuildingNumber: "5",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8K12AK",
    },
    {
      BuildingNumber: "5",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72s2AC",
    },
    {
      BuildingNumber: "5",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsR2AQ",
    },
    {
      BuildingNumber: "5",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RY2A0",
    },
    {
      BuildingNumber: "5",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yEF2AY",
    },
    {
      BuildingNumber: "5",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6lB2AS",
    },
    {
      BuildingNumber: "5",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8qC2AS",
    },
    {
      BuildingNumber: "5",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2JT2A0",
    },
    {
      BuildingNumber: "5",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oF2AS",
    },
    {
      BuildingNumber: "5",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zP2AS",
    },
    {
      BuildingNumber: "5",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8zr2AC",
    },
    {
      BuildingNumber: "5",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vy82AA",
    },
    {
      BuildingNumber: "50",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EN2A0",
    },
    {
      BuildingNumber: "50",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m62AC",
    },
    {
      BuildingNumber: "50",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kd2AK",
    },
    {
      BuildingNumber: "50",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E62AK",
    },
    {
      BuildingNumber: "50",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Um2AK",
    },
    {
      BuildingNumber: "50",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R32AK",
    },
    {
      BuildingNumber: "51",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7al2AC",
    },
    {
      BuildingNumber: "51",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zh2AC",
    },
    {
      BuildingNumber: "51",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z282AA",
    },
    {
      BuildingNumber: "51",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TU2A0",
    },
    {
      BuildingNumber: "52",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6202AC",
    },
    {
      BuildingNumber: "52",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ko2AK",
    },
    {
      BuildingNumber: "52",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R92AK",
    },
    {
      BuildingNumber: "52",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72w2AC",
    },
    {
      BuildingNumber: "52",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Pj2AK",
    },
    {
      BuildingNumber: "53",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gl2AK",
    },
    {
      BuildingNumber: "53",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zez2AA",
    },
    {
      BuildingNumber: "53",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e42AC",
    },
    {
      BuildingNumber: "53",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xJ2AS",
    },
    {
      BuildingNumber: "54",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7am2AC",
    },
    {
      BuildingNumber: "54",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zi2AC",
    },
    {
      BuildingNumber: "54",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xC2AS",
    },
    {
      BuildingNumber: "54",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3KO2A0",
    },
    {
      BuildingNumber: "55",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5W2AQ",
    },
    {
      BuildingNumber: "55",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kj2AK",
    },
    {
      BuildingNumber: "55",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A18p2AC",
    },
    {
      BuildingNumber: "55",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77m2AC",
    },
    {
      BuildingNumber: "55",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mo2AK",
    },
    {
      BuildingNumber: "56",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2OK2A0",
    },
    {
      BuildingNumber: "56",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEz2AI",
    },
    {
      BuildingNumber: "56",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A43T2AS",
    },
    {
      BuildingNumber: "56",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7dz2AC",
    },
    {
      BuildingNumber: "57",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oG2AS",
    },
    {
      BuildingNumber: "57",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4me2AC",
    },
    {
      BuildingNumber: "57",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rS2AS",
    },
    {
      BuildingNumber: "57",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZS2A0",
    },
    {
      BuildingNumber: "58",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3oz2AC",
    },
    {
      BuildingNumber: "58",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qz2AK",
    },
    {
      BuildingNumber: "58",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Iz2AK",
    },
    {
      BuildingNumber: "59",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60T2AS",
    },
    {
      BuildingNumber: "59",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4562AC",
    },
    {
      BuildingNumber: "59",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrQ2AQ",
    },
    {
      BuildingNumber: "59",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1SD2A0",
    },
    {
      BuildingNumber: "6",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pJ2AS",
    },
    {
      BuildingNumber: "6",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8mx2AC",
    },
    {
      BuildingNumber: "6",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HO2A0",
    },
    {
      BuildingNumber: "6",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xmm2AA",
    },
    {
      BuildingNumber: "6",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9HZ2A0",
    },
    {
      BuildingNumber: "6",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1X22AK",
    },
    {
      BuildingNumber: "6",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zro2AA",
    },
    {
      BuildingNumber: "6",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqC2AQ",
    },
    {
      BuildingNumber: "6",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g92AC",
    },
    {
      BuildingNumber: "6",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tw2AC",
    },
    {
      BuildingNumber: "6",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PD2A0",
    },
    {
      BuildingNumber: "6",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjm2AA",
    },
    {
      BuildingNumber: "60",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ef2AK",
    },
    {
      BuildingNumber: "60",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vy92AA",
    },
    {
      BuildingNumber: "60",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vd2AK",
    },
    {
      BuildingNumber: "60",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUQ2AY",
    },
    {
      BuildingNumber: "60",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ynr2AA",
    },
    {
      BuildingNumber: "61",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F72AK",
    },
    {
      BuildingNumber: "61",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzU2AQ",
    },
    {
      BuildingNumber: "61",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2BO2A0",
    },
    {
      BuildingNumber: "61",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e12AC",
    },
    {
      BuildingNumber: "62",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LP2A0",
    },
    {
      BuildingNumber: "62",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Z72AK",
    },
    {
      BuildingNumber: "62",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77l2AC",
    },
    {
      BuildingNumber: "62",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOb2AI",
    },
    {
      BuildingNumber: "62",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y4T2AQ",
    },
    {
      BuildingNumber: "63",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sl2AK",
    },
    {
      BuildingNumber: "63",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZC2AY",
    },
    {
      BuildingNumber: "63",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RV2A0",
    },
    {
      BuildingNumber: "63",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ME2A0",
    },
    {
      BuildingNumber: "64",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6wP2AS",
    },
    {
      BuildingNumber: "64",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xV62AI",
    },
    {
      BuildingNumber: "64",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wM82AI",
    },
    {
      BuildingNumber: "64",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysb2AA",
    },
    {
      BuildingNumber: "64",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5192AC",
    },
    {
      BuildingNumber: "65",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZR2A0",
    },
    {
      BuildingNumber: "65",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrj2AA",
    },
    {
      BuildingNumber: "65",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g62AC",
    },
    {
      BuildingNumber: "65",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn42AA",
    },
    {
      BuildingNumber: "65",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgN2AQ",
    },
    {
      BuildingNumber: "66",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y22AC",
    },
    {
      BuildingNumber: "66",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Z82AK",
    },
    {
      BuildingNumber: "66",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPQ2AY",
    },
    {
      BuildingNumber: "66",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nf2AC",
    },
    {
      BuildingNumber: "66",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5U2AQ",
    },
    {
      BuildingNumber: "67",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yT2AS",
    },
    {
      BuildingNumber: "67",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOc2AI",
    },
    {
      BuildingNumber: "67",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zOp2AI",
    },
    {
      BuildingNumber: "67",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83n2AC",
    },
    {
      BuildingNumber: "67",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AF2A0",
    },
    {
      BuildingNumber: "67",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZD2A0",
    },
    {
      BuildingNumber: "68",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0812AC",
    },
    {
      BuildingNumber: "68",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wE22AI",
    },
    {
      BuildingNumber: "68",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g72AC",
    },
    {
      BuildingNumber: "68",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3sC2AS",
    },
    {
      BuildingNumber: "68",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40K2AS",
    },
    {
      BuildingNumber: "69",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsU2AQ",
    },
    {
      BuildingNumber: "69",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e52AC",
    },
    {
      BuildingNumber: "69",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UJ2A0",
    },
    {
      BuildingNumber: "69",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYY2AY",
    },
    {
      BuildingNumber: "69",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G82AK",
    },
    {
      BuildingNumber: "69",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kA2AS",
    },
    {
      BuildingNumber: "7",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3lj2AC",
    },
    {
      BuildingNumber: "7",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6OY2A0",
    },
    {
      BuildingNumber: "7",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G92AK",
    },
    {
      BuildingNumber: "7",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za52AA",
    },
    {
      BuildingNumber: "7",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jk2AK",
    },
    {
      BuildingNumber: "7",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jv2AK",
    },
    {
      BuildingNumber: "7",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8K2AQ",
    },
    {
      BuildingNumber: "7",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A51A2AS",
    },
    {
      BuildingNumber: "7",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fq2AK",
    },
    {
      BuildingNumber: "7",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bu2AK",
    },
    {
      BuildingNumber: "7",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vhe2AA",
    },
    {
      BuildingNumber: "7",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bU2AS",
    },
    {
      BuildingNumber: "7",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ee2AK",
    },
    {
      BuildingNumber: "7",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySj2AI",
    },
    {
      BuildingNumber: "70",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3de2AC",
    },
    {
      BuildingNumber: "70",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0kj2AC",
    },
    {
      BuildingNumber: "70",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ro2AK",
    },
    {
      BuildingNumber: "70",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xet2AA",
    },
    {
      BuildingNumber: "70",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEv2AI",
    },
    {
      BuildingNumber: "70",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yam2AA",
    },
    {
      BuildingNumber: "71",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VE2A0",
    },
    {
      BuildingNumber: "71",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg42AA",
    },
    {
      BuildingNumber: "71",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6rc2AC",
    },
    {
      BuildingNumber: "71",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wU62AI",
    },
    {
      BuildingNumber: "71",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kb2AK",
    },
    {
      BuildingNumber: "72",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sW2AS",
    },
    {
      BuildingNumber: "72",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rs2AK",
    },
    {
      BuildingNumber: "72",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YF2A0",
    },
    {
      BuildingNumber: "72",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5R02AK",
    },
    {
      BuildingNumber: "72",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A09V2AS",
    },
    {
      BuildingNumber: "72",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yME2AY",
    },
    {
      BuildingNumber: "72",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vul2AA",
    },
    {
      BuildingNumber: "73",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MD2A0",
    },
    {
      BuildingNumber: "73",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5UB2A0",
    },
    {
      BuildingNumber: "73",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5qh2AC",
    },
    {
      BuildingNumber: "73",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEu2AI",
    },
    {
      BuildingNumber: "73",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zLb2AI",
    },
    {
      BuildingNumber: "73",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0MP2A0",
    },
    {
      BuildingNumber: "74",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1de2AC",
    },
    {
      BuildingNumber: "74",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjO2AQ",
    },
    {
      BuildingNumber: "74",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UI2A0",
    },
    {
      BuildingNumber: "74",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8v12AC",
    },
    {
      BuildingNumber: "74",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yan2AA",
    },
    {
      BuildingNumber: "75",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5EB2A0",
    },
    {
      BuildingNumber: "75",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L72AK",
    },
    {
      BuildingNumber: "75",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1db2AC",
    },
    {
      BuildingNumber: "75",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41u2AC",
    },
    {
      BuildingNumber: "76",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xje2AA",
    },
    {
      BuildingNumber: "76",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72y2AC",
    },
    {
      BuildingNumber: "76",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0xV2AS",
    },
    {
      BuildingNumber: "76",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGq2AI",
    },
    {
      BuildingNumber: "76",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgO2AQ",
    },
    {
      BuildingNumber: "77",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYS2AY",
    },
    {
      BuildingNumber: "77",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LQ2A0",
    },
    {
      BuildingNumber: "77",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnX2AQ",
    },
    {
      BuildingNumber: "77",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TQ2A0",
    },
    {
      BuildingNumber: "77",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PH2A0",
    },
    {
      BuildingNumber: "78",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2jM2AS",
    },
    {
      BuildingNumber: "78",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4QB2A0",
    },
    {
      BuildingNumber: "78",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rn2AK",
    },
    {
      BuildingNumber: "78",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5ab2AC",
    },
    {
      BuildingNumber: "78",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1tb2AC",
    },
    {
      BuildingNumber: "79",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gi2AK",
    },
    {
      BuildingNumber: "79",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zN2AS",
    },
    {
      BuildingNumber: "79",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bq2AK",
    },
    {
      BuildingNumber: "79",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzs2AA",
    },
    {
      BuildingNumber: "79",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yao2AA",
    },
    {
      BuildingNumber: "8",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EO2A0",
    },
    {
      BuildingNumber: "8",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hS2AS",
    },
    {
      BuildingNumber: "8",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwh2AA",
    },
    {
      BuildingNumber: "8",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sK2AS",
    },
    {
      BuildingNumber: "8",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80Z2AS",
    },
    {
      BuildingNumber: "8",
      Street: "CROSS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yxI2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yRD2AY",
    },
    {
      BuildingNumber: "8",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TO2A0",
    },
    {
      BuildingNumber: "8",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqB2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019waa2AA",
    },
    {
      BuildingNumber: "8",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fp2AK",
    },
    {
      BuildingNumber: "8",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rk2AK",
    },
    {
      BuildingNumber: "8",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlI2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZT2A0",
    },
    {
      BuildingNumber: "8",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KY2A0",
    },
    {
      BuildingNumber: "80",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41s2AC",
    },
    {
      BuildingNumber: "80",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R82AK",
    },
    {
      BuildingNumber: "80",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjN2AQ",
    },
    {
      BuildingNumber: "80",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15g2AC",
    },
    {
      BuildingNumber: "80",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1C62AK",
    },
    {
      BuildingNumber: "81",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41t2AC",
    },
    {
      BuildingNumber: "81",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Az2AK",
    },
    {
      BuildingNumber: "81",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8LW2A0",
    },
    {
      BuildingNumber: "81",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Cj2AK",
    },
    {
      BuildingNumber: "81",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eq2AK",
    },
    {
      BuildingNumber: "82",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PG2A0",
    },
    {
      BuildingNumber: "82",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ss2AK",
    },
    {
      BuildingNumber: "82",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fc2AC",
    },
    {
      BuildingNumber: "82",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vma2AA",
    },
    {
      BuildingNumber: "83",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gE2AS",
    },
    {
      BuildingNumber: "83",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6I72AK",
    },
    {
      BuildingNumber: "83",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RZ2A0",
    },
    {
      BuildingNumber: "83",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l42AC",
    },
    {
      BuildingNumber: "83",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l22AC",
    },
    {
      BuildingNumber: "84",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1IX2A0",
    },
    {
      BuildingNumber: "84",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8a32AC",
    },
    {
      BuildingNumber: "84",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A51B2AS",
    },
    {
      BuildingNumber: "84",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65I2AS",
    },
    {
      BuildingNumber: "85",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5M2AQ",
    },
    {
      BuildingNumber: "85",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72x2AC",
    },
    {
      BuildingNumber: "85",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MQ2A0",
    },
    {
      BuildingNumber: "85",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q42AK",
    },
    {
      BuildingNumber: "85",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d62AC",
    },
    {
      BuildingNumber: "85",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z292AA",
    },
    {
      BuildingNumber: "86",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWh2AI",
    },
    {
      BuildingNumber: "86",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7XV2A0",
    },
    {
      BuildingNumber: "86",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6gK2AS",
    },
    {
      BuildingNumber: "86",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A71H2AS",
    },
    {
      BuildingNumber: "86",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E92AK",
    },
    {
      BuildingNumber: "87",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w192AA",
    },
    {
      BuildingNumber: "87",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zr2AK",
    },
    {
      BuildingNumber: "87",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s32AC",
    },
    {
      BuildingNumber: "87",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Dk2AK",
    },
    {
      BuildingNumber: "87",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e02AC",
    },
    {
      BuildingNumber: "88",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWi2AI",
    },
    {
      BuildingNumber: "88",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0822AC",
    },
    {
      BuildingNumber: "88",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpy2AA",
    },
    {
      BuildingNumber: "88",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrg2AA",
    },
    {
      BuildingNumber: "88",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MG2A0",
    },
    {
      BuildingNumber: "89",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Np2AK",
    },
    {
      BuildingNumber: "89",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8K02AK",
    },
    {
      BuildingNumber: "89",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpz2AA",
    },
    {
      BuildingNumber: "89",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CK2A0",
    },
    {
      BuildingNumber: "89",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn32AA",
    },
    {
      BuildingNumber: "9",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsT2AQ",
    },
    {
      BuildingNumber: "9",
      Street: "BOND ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8ob2AC",
    },
    {
      BuildingNumber: "9",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7W02AK",
    },
    {
      BuildingNumber: "9",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Uk2AK",
    },
    {
      BuildingNumber: "9",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn52AA",
    },
    {
      BuildingNumber: "9",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoW2AQ",
    },
    {
      BuildingNumber: "9",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gX2AS",
    },
    {
      BuildingNumber: "9",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yap2AA",
    },
    {
      BuildingNumber: "9",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jW2AS",
    },
    {
      BuildingNumber: "9",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qw2AK",
    },
    {
      BuildingNumber: "9",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WU2A0",
    },
    {
      BuildingNumber: "9",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bX2AS",
    },
    {
      BuildingNumber: "9",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGs2AI",
    },
    {
      BuildingNumber: "9",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5aZ2AS",
    },
    {
      BuildingNumber: "9",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za32AA",
    },
    {
      BuildingNumber: "9",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m22AC",
    },
    {
      BuildingNumber: "9",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9UT2A0",
    },
    {
      BuildingNumber: "9",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYU2AY",
    },
    {
      BuildingNumber: "90",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yEG2AY",
    },
    {
      BuildingNumber: "90",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e32AC",
    },
    {
      BuildingNumber: "90",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mc2AC",
    },
    {
      BuildingNumber: "90",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6V02AK",
    },
    {
      BuildingNumber: "91",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tO2AS",
    },
    {
      BuildingNumber: "91",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y12AC",
    },
    {
      BuildingNumber: "91",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7EC2A0",
    },
    {
      BuildingNumber: "91",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kf2AK",
    },
    {
      BuildingNumber: "92",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57Z2AS",
    },
    {
      BuildingNumber: "92",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Et2AK",
    },
    {
      BuildingNumber: "92",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoU2AQ",
    },
    {
      BuildingNumber: "92",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7qs2AC",
    },
    {
      BuildingNumber: "92",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYQ2AY",
    },
    {
      BuildingNumber: "93",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3122AC",
    },
    {
      BuildingNumber: "93",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4552AC",
    },
    {
      BuildingNumber: "93",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sX2AS",
    },
    {
      BuildingNumber: "93",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlM2AQ",
    },
    {
      BuildingNumber: "93",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rr2AK",
    },
    {
      BuildingNumber: "93",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ju2AK",
    },
    {
      BuildingNumber: "94",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1C92AK",
    },
    {
      BuildingNumber: "94",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9W52AK",
    },
    {
      BuildingNumber: "94",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kc2AK",
    },
    {
      BuildingNumber: "94",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lw2AC",
    },
    {
      BuildingNumber: "95",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w4R2AQ",
    },
    {
      BuildingNumber: "95",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qb2AC",
    },
    {
      BuildingNumber: "95",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u92AC",
    },
    {
      BuildingNumber: "95",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6N22AK",
    },
    {
      BuildingNumber: "95",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPS2AY",
    },
    {
      BuildingNumber: "95",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Es2AK",
    },
    {
      BuildingNumber: "96",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4cz2AC",
    },
    {
      BuildingNumber: "96",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6eh2AC",
    },
    {
      BuildingNumber: "96",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ba2AC",
    },
    {
      BuildingNumber: "96",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8wc2AC",
    },
    {
      BuildingNumber: "96",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xs2AK",
    },
    {
      BuildingNumber: "97",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yuD2AQ",
    },
    {
      BuildingNumber: "97",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Va2AK",
    },
    {
      BuildingNumber: "97",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ni2AC",
    },
    {
      BuildingNumber: "97",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yX2AS",
    },
    {
      BuildingNumber: "97",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A91R2AS",
    },
    {
      BuildingNumber: "97",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8b2AA",
    },
    {
      BuildingNumber: "97",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A88c2AC",
    },
    {
      BuildingNumber: "98",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qy2AK",
    },
    {
      BuildingNumber: "98",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6l92AC",
    },
    {
      BuildingNumber: "98",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8ji2AC",
    },
    {
      BuildingNumber: "98",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8mv2AC",
    },
    {
      BuildingNumber: "99",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjM2AQ",
    },
    {
      BuildingNumber: "99",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZE2AY",
    },
    {
      BuildingNumber: "99",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xF12AI",
    },
    {
      BuildingNumber: "99",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8yD2AS",
    },
    {
      BuildingNumber: "99",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sW2AS",
    },
    {
      BuildingNumber: "99",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZE2A0",
    },
    {
      BuildingNumber: "9A",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68S2AS",
    },
    {
      BuildingNumber: "185",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zY2AS",
    },
    {
      BuildingNumber: "185",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vj2AC",
    },
    {
      BuildingNumber: "187",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xA2AS",
    },
    {
      BuildingNumber: "188",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A88b2AC",
    },
    {
      BuildingNumber: "188",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ze2AC",
    },
    {
      BuildingNumber: "189",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5x92AC",
    },
    {
      BuildingNumber: "189",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDM2AY",
    },
    {
      BuildingNumber: "19",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lr2AC",
    },
    {
      BuildingNumber: "19",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5nT2AS",
    },
    {
      BuildingNumber: "19",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65E2AS",
    },
    {
      BuildingNumber: "19",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UX2A0",
    },
    {
      BuildingNumber: "19",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xF2AS",
    },
    {
      BuildingNumber: "19",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63c2AC",
    },
    {
      BuildingNumber: "19",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Ym2AK",
    },
    {
      BuildingNumber: "19",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ep2AK",
    },
    {
      BuildingNumber: "19",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Pi2AK",
    },
    {
      BuildingNumber: "19",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5aY2AS",
    },
    {
      BuildingNumber: "19",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sT2AS",
    },
    {
      BuildingNumber: "19",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZU2A0",
    },
    {
      BuildingNumber: "190",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72u2AC",
    },
    {
      BuildingNumber: "190",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Rb2AK",
    },
    {
      BuildingNumber: "191",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3VZ2A0",
    },
    {
      BuildingNumber: "192",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60O2AS",
    },
    {
      BuildingNumber: "192",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MH2A0",
    },
    {
      BuildingNumber: "193",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rq2AK",
    },
    {
      BuildingNumber: "194",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E52AK",
    },
    {
      BuildingNumber: "196",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zi62AA",
    },
    {
      BuildingNumber: "196",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS82AI",
    },
    {
      BuildingNumber: "197",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5SX2A0",
    },
    {
      BuildingNumber: "197",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LM2A0",
    },
    {
      BuildingNumber: "197",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnT2AQ",
    },
    {
      BuildingNumber: "198",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UV2A0",
    },
    {
      BuildingNumber: "199",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4kz2AC",
    },
    {
      BuildingNumber: "2",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5yk2AC",
    },
    {
      BuildingNumber: "2",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xtB2AQ",
    },
    {
      BuildingNumber: "2",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MI2A0",
    },
    {
      BuildingNumber: "2",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yas2AA",
    },
    {
      BuildingNumber: "2",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vc2AK",
    },
    {
      BuildingNumber: "2",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Er2AK",
    },
    {
      BuildingNumber: "2",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrP2AQ",
    },
    {
      BuildingNumber: "20",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YH2A0",
    },
    {
      BuildingNumber: "20",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6up2AC",
    },
    {
      BuildingNumber: "20",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nj2AC",
    },
    {
      BuildingNumber: "20",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ck2AK",
    },
    {
      BuildingNumber: "20",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xTX2AY",
    },
    {
      BuildingNumber: "20",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5622AC",
    },
    {
      BuildingNumber: "20",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qy2AK",
    },
    {
      BuildingNumber: "20",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rT2AS",
    },
    {
      BuildingNumber: "20",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Nq2AK",
    },
    {
      BuildingNumber: "20",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nM2AS",
    },
    {
      BuildingNumber: "20",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zO2AS",
    },
    {
      BuildingNumber: "20",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TJ2A0",
    },
    {
      BuildingNumber: "20",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7XX2A0",
    },
    {
      BuildingNumber: "200",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A21b2AC",
    },
    {
      BuildingNumber: "200",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sS2AS",
    },
    {
      BuildingNumber: "201",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77h2AC",
    },
    {
      BuildingNumber: "201",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68R2AS",
    },
    {
      BuildingNumber: "202",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vk2AK",
    },
    {
      BuildingNumber: "203",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOX2AY",
    },
    {
      BuildingNumber: "204",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xja2AA",
    },
    {
      BuildingNumber: "205",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0nu2AC",
    },
    {
      BuildingNumber: "206",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ov2AC",
    },
    {
      BuildingNumber: "206",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lv2AC",
    },
    {
      BuildingNumber: "207",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mb2AK",
    },
    {
      BuildingNumber: "207",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83l2AC",
    },
    {
      BuildingNumber: "208",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y32AC",
    },
    {
      BuildingNumber: "208",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60S2AS",
    },
    {
      BuildingNumber: "209",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5H2AQ",
    },
    {
      BuildingNumber: "21",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg22AA",
    },
    {
      BuildingNumber: "21",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gj2AK",
    },
    {
      BuildingNumber: "21",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kG2AS",
    },
    {
      BuildingNumber: "21",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9fl2AC",
    },
    {
      BuildingNumber: "21",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrO2AQ",
    },
    {
      BuildingNumber: "21",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7dy2AC",
    },
    {
      BuildingNumber: "21",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0uN2AS",
    },
    {
      BuildingNumber: "21",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ42AI",
    },
    {
      BuildingNumber: "21",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yar2AA",
    },
    {
      BuildingNumber: "21",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3tk2AC",
    },
    {
      BuildingNumber: "21",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vW2AS",
    },
    {
      BuildingNumber: "21",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AG2A0",
    },
    {
      BuildingNumber: "210",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Yn2AK",
    },
    {
      BuildingNumber: "210",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQT2AY",
    },
    {
      BuildingNumber: "211A",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E82AK",
    },
    {
      BuildingNumber: "214",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gh2AK",
    },
    {
      BuildingNumber: "215",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Be2AK",
    },
    {
      BuildingNumber: "216",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8jh2AC",
    },
    {
      BuildingNumber: "219",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l12AC",
    },
    {
      BuildingNumber: "22",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y42AC",
    },
    {
      BuildingNumber: "22",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ZJ2A0",
    },
    {
      BuildingNumber: "22",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6I62AK",
    },
    {
      BuildingNumber: "22",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrq2AA",
    },
    {
      BuildingNumber: "22",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tC2AS",
    },
    {
      BuildingNumber: "22",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1lU2AS",
    },
    {
      BuildingNumber: "22",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x6o2AA",
    },
    {
      BuildingNumber: "22",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7cN2AS",
    },
    {
      BuildingNumber: "22",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bQ2AS",
    },
    {
      BuildingNumber: "22",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7PR2A0",
    },
    {
      BuildingNumber: "22",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l52AC",
    },
    {
      BuildingNumber: "220",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5G2AQ",
    },
    {
      BuildingNumber: "223",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8i52AC",
    },
    {
      BuildingNumber: "224",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lu2AC",
    },
    {
      BuildingNumber: "227",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4eg2AC",
    },
    {
      BuildingNumber: "228",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8YQ2A0",
    },
    {
      BuildingNumber: "23",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hR2AS",
    },
    {
      BuildingNumber: "23",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7cL2AS",
    },
    {
      BuildingNumber: "23",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5672AC",
    },
    {
      BuildingNumber: "23",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5du2AC",
    },
    {
      BuildingNumber: "23",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xmo2AA",
    },
    {
      BuildingNumber: "23",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3li2AC",
    },
    {
      BuildingNumber: "23",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlK2AQ",
    },
    {
      BuildingNumber: "23",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A86z2AC",
    },
    {
      BuildingNumber: "23",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5662AC",
    },
    {
      BuildingNumber: "23",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0uM2AS",
    },
    {
      BuildingNumber: "23",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GA2A0",
    },
    {
      BuildingNumber: "231",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDL2AY",
    },
    {
      BuildingNumber: "232",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xM2AS",
    },
    {
      BuildingNumber: "235",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y4S2AQ",
    },
    {
      BuildingNumber: "236",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TS2A0",
    },
    {
      BuildingNumber: "239",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wkQ2AQ",
    },
    {
      BuildingNumber: "24",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nk2AC",
    },
    {
      BuildingNumber: "24",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9av2AC",
    },
    {
      BuildingNumber: "24",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySl2AI",
    },
    {
      BuildingNumber: "24",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xwO2AQ",
    },
    {
      BuildingNumber: "24",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sy2AK",
    },
    {
      BuildingNumber: "24",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za12AA",
    },
    {
      BuildingNumber: "24",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77p2AC",
    },
    {
      BuildingNumber: "24",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A18o2AC",
    },
    {
      BuildingNumber: "24",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xey2AA",
    },
    {
      BuildingNumber: "24",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A09U2AS",
    },
    {
      BuildingNumber: "24",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3FR2A0",
    },
    {
      BuildingNumber: "240",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2eS2AS",
    },
    {
      BuildingNumber: "241",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuk2AA",
    },
    {
      BuildingNumber: "243",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zdF2AQ",
    },
    {
      BuildingNumber: "244",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5PJ2A0",
    },
    {
      BuildingNumber: "247",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5T2AQ",
    },
    {
      BuildingNumber: "248",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzq2AA",
    },
    {
      BuildingNumber: "25",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Gz2AK",
    },
    {
      BuildingNumber: "25",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oH2AS",
    },
    {
      BuildingNumber: "25",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDy2AI",
    },
    {
      BuildingNumber: "25",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xE2AS",
    },
    {
      BuildingNumber: "25",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Wd2AK",
    },
    {
      BuildingNumber: "25",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8Y2AQ",
    },
    {
      BuildingNumber: "25",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4md2AC",
    },
    {
      BuildingNumber: "25",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nN2AS",
    },
    {
      BuildingNumber: "25",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1IW2A0",
    },
    {
      BuildingNumber: "25",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fn2AK",
    },
    {
      BuildingNumber: "250",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8S02AK",
    },
    {
      BuildingNumber: "251",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZC2A0",
    },
    {
      BuildingNumber: "252",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vpl2AA",
    },
    {
      BuildingNumber: "26",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjb2AA",
    },
    {
      BuildingNumber: "26",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEx2AI",
    },
    {
      BuildingNumber: "26",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A82A2AS",
    },
    {
      BuildingNumber: "26",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A48K2AS",
    },
    {
      BuildingNumber: "26",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y32AC",
    },
    {
      BuildingNumber: "26",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1CB2A0",
    },
    {
      BuildingNumber: "26",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wtz2AA",
    },
    {
      BuildingNumber: "26",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CI2A0",
    },
    {
      BuildingNumber: "26",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d52AC",
    },
    {
      BuildingNumber: "26",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqF2AQ",
    },
    {
      BuildingNumber: "26",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Yp2AK",
    },
    {
      BuildingNumber: "26",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cu2AK",
    },
    {
      BuildingNumber: "26",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgK2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80X2AS",
    },
    {
      BuildingNumber: "27",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wu12AA",
    },
    {
      BuildingNumber: "27",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8M2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za62AA",
    },
    {
      BuildingNumber: "27",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqE2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zLZ2AY",
    },
    {
      BuildingNumber: "27",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnU2AQ",
    },
    {
      BuildingNumber: "27",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LL2A0",
    },
    {
      BuildingNumber: "27",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jX2AS",
    },
    {
      BuildingNumber: "27",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TN2A0",
    },
    {
      BuildingNumber: "28",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57b2AC",
    },
    {
      BuildingNumber: "28",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tE2AS",
    },
    {
      BuildingNumber: "28",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jZ2AS",
    },
    {
      BuildingNumber: "28",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mr2AK",
    },
    {
      BuildingNumber: "28",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MR2A0",
    },
    {
      BuildingNumber: "28",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6pz2AC",
    },
    {
      BuildingNumber: "28",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4d02AC",
    },
    {
      BuildingNumber: "28",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgM2AQ",
    },
    {
      BuildingNumber: "28",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5F2AQ",
    },
    {
      BuildingNumber: "28",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9uH2AS",
    },
    {
      BuildingNumber: "28",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Kn2AK",
    },
    {
      BuildingNumber: "29",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1NO2A0",
    },
    {
      BuildingNumber: "29",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hG2AS",
    },
    {
      BuildingNumber: "29",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgL2AQ",
    },
    {
      BuildingNumber: "29",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1NN2A0",
    },
    {
      BuildingNumber: "29",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysZ2AQ",
    },
    {
      BuildingNumber: "29",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nL2AS",
    },
    {
      BuildingNumber: "29",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65F2AS",
    },
    {
      BuildingNumber: "29",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZV2A0",
    },
    {
      BuildingNumber: "3",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sN2AS",
    },
    {
      BuildingNumber: "3",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xzp2AA",
    },
    {
      BuildingNumber: "3",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8oY2AS",
    },
    {
      BuildingNumber: "3",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0pW2AS",
    },
    {
      BuildingNumber: "3",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sR2AS",
    },
    {
      BuildingNumber: "3",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEw2AI",
    },
    {
      BuildingNumber: "3",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A23K2AS",
    },
    {
      BuildingNumber: "3",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ztR2AQ",
    },
    {
      BuildingNumber: "3",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tN2AS",
    },
    {
      BuildingNumber: "3",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MF2A0",
    },
    {
      BuildingNumber: "3",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8lK2AS",
    },
    {
      BuildingNumber: "3",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Zd2AK",
    },
    {
      BuildingNumber: "3",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5id2AC",
    },
    {
      BuildingNumber: "3",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zyE2AQ",
    },
    {
      BuildingNumber: "3",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3KN2A0",
    },
    {
      BuildingNumber: "30",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjQ2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KV2A0",
    },
    {
      BuildingNumber: "30",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5V2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9cX2AS",
    },
    {
      BuildingNumber: "30",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GY2A0",
    },
    {
      BuildingNumber: "30",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZH2AY",
    },
    {
      BuildingNumber: "30",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TP2A0",
    },
    {
      BuildingNumber: "30",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPR2AY",
    },
    {
      BuildingNumber: "30",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsQ2AQ",
    },
    {
      BuildingNumber: "30",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kL2AS",
    },
    {
      BuildingNumber: "30",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ZL2A0",
    },
    {
      BuildingNumber: "30",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32h2AC",
    },
    {
      BuildingNumber: "30",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3tm2AC",
    },
    {
      BuildingNumber: "30",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d92AC",
    },
    {
      BuildingNumber: "31",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bR2AS",
    },
    {
      BuildingNumber: "31",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9JB2A0",
    },
    {
      BuildingNumber: "31",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eo2AK",
    },
    {
      BuildingNumber: "31",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ns2AK",
    },
    {
      BuildingNumber: "31",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yR92AI",
    },
    {
      BuildingNumber: "31",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q72AK",
    },
    {
      BuildingNumber: "31",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63b2AC",
    },
    {
      BuildingNumber: "31",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3oy2AC",
    },
    {
      BuildingNumber: "32",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L32AK",
    },
    {
      BuildingNumber: "32",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS62AI",
    },
    {
      BuildingNumber: "32",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y62AC",
    },
    {
      BuildingNumber: "32",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0362AC",
    },
    {
      BuildingNumber: "32",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57a2AC",
    },
    {
      BuildingNumber: "32",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zk2AC",
    },
    {
      BuildingNumber: "32",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PK2A0",
    },
    {
      BuildingNumber: "32",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7vh2AC",
    },
    {
      BuildingNumber: "32",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zs2AK",
    },
    {
      BuildingNumber: "32",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fo2AK",
    },
    {
      BuildingNumber: "32",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dL2AS",
    },
    {
      BuildingNumber: "32",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A96J2AS",
    },
    {
      BuildingNumber: "32",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E42AK",
    },
    {
      BuildingNumber: "3291",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jy2AK",
    },
    {
      BuildingNumber: "3297",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vY2AS",
    },
    {
      BuildingNumber: "33",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDz2AI",
    },
    {
      BuildingNumber: "33",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CJ2A0",
    },
    {
      BuildingNumber: "33",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xjf2AA",
    },
    {
      BuildingNumber: "33",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrW2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQS2AY",
    },
    {
      BuildingNumber: "33",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqD2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Lu2AK",
    },
    {
      BuildingNumber: "33",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eC2AS",
    },
    {
      BuildingNumber: "33",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ph2AK",
    },
    {
      BuildingNumber: "33",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zdE2AQ",
    },
    {
      BuildingNumber: "33",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yR72AI",
    },
    {
      BuildingNumber: "3303",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zIO2AY",
    },
    {
      BuildingNumber: "3316",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgQ2AQ",
    },
    {
      BuildingNumber: "3318",
      Street: "WESTERWALD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAp2AI",
    },
    {
      BuildingNumber: "34",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySk2AI",
    },
    {
      BuildingNumber: "34",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65G2AS",
    },
    {
      BuildingNumber: "34",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Ng2AK",
    },
    {
      BuildingNumber: "34",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4hm2AC",
    },
    {
      BuildingNumber: "34",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5N2AQ",
    },
    {
      BuildingNumber: "34",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4t32AC",
    },
    {
      BuildingNumber: "34",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7qu2AC",
    },
    {
      BuildingNumber: "34",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wab2AA",
    },
    {
      BuildingNumber: "34",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w7f2AA",
    },
    {
      BuildingNumber: "34",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yh2AK",
    },
    {
      BuildingNumber: "34",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ca2AC",
    },
    {
      BuildingNumber: "34",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xq2AK",
    },
    {
      BuildingNumber: "34",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzV2AQ",
    },
    {
      BuildingNumber: "3422",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32k2AC",
    },
    {
      BuildingNumber: "3426",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0802AC",
    },
    {
      BuildingNumber: "3450",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F62AK",
    },
    {
      BuildingNumber: "35",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72v2AC",
    },
    {
      BuildingNumber: "35",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kT2AS",
    },
    {
      BuildingNumber: "35",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TC2A0",
    },
    {
      BuildingNumber: "35",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0MQ2A0",
    },
    {
      BuildingNumber: "35",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oP2AS",
    },
    {
      BuildingNumber: "35",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6wQ2AS",
    },
    {
      BuildingNumber: "35",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Fx2AK",
    },
    {
      BuildingNumber: "35",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vu2AK",
    },
    {
      BuildingNumber: "36",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6A62AK",
    },
    {
      BuildingNumber: "36",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R42AK",
    },
    {
      BuildingNumber: "36",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eu2AK",
    },
    {
      BuildingNumber: "36",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4y42AC",
    },
    {
      BuildingNumber: "36",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p92AC",
    },
    {
      BuildingNumber: "36",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A24s2AC",
    },
    {
      BuildingNumber: "36",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y62AC",
    },
    {
      BuildingNumber: "36",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mi2AC",
    },
    {
      BuildingNumber: "36",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5vX2AS",
    },
    {
      BuildingNumber: "36",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85N2AS",
    },
    {
      BuildingNumber: "36",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74T2AS",
    },
    {
      BuildingNumber: "36",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDK2AY",
    },
    {
      BuildingNumber: "36",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3ow2AC",
    },
    {
      BuildingNumber: "36",
      Street: "VIMY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PJ2A0",
    },
    {
      BuildingNumber: "37",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqw2AA",
    },
    {
      BuildingNumber: "37",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWk2AI",
    },
    {
      BuildingNumber: "37",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8V2AQ",
    },
    {
      BuildingNumber: "37",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bT2AS",
    },
    {
      BuildingNumber: "37",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77n2AC",
    },
    {
      BuildingNumber: "37",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A49z2AC",
    },
    {
      BuildingNumber: "37",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ki2AK",
    },
    {
      BuildingNumber: "37",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oO2AS",
    },
    {
      BuildingNumber: "37",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAm2AI",
    },
    {
      BuildingNumber: "3722",
      Street: "DUTCH VILLAGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xF22AI",
    },
    {
      BuildingNumber: "38",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xre2AA",
    },
    {
      BuildingNumber: "38",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUO2AY",
    },
    {
      BuildingNumber: "38",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72z2AC",
    },
    {
      BuildingNumber: "38",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjl2AA",
    },
    {
      BuildingNumber: "38",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlN2AQ",
    },
    {
      BuildingNumber: "38",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7692AC",
    },
    {
      BuildingNumber: "38",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tD2AS",
    },
    {
      BuildingNumber: "38",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xK2AS",
    },
    {
      BuildingNumber: "38",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A76A2AS",
    },
    {
      BuildingNumber: "38",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eD2AS",
    },
    {
      BuildingNumber: "38",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bS2AS",
    },
    {
      BuildingNumber: "38",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fd2AC",
    },
    {
      BuildingNumber: "39",
      Street: "ASHDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A26V2AS",
    },
    {
      BuildingNumber: "39",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ki2AC",
    },
    {
      BuildingNumber: "39",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rU2AS",
    },
    {
      BuildingNumber: "39",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cw2AK",
    },
    {
      BuildingNumber: "39",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuj2AA",
    },
    {
      BuildingNumber: "39",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wlt2AA",
    },
    {
      BuildingNumber: "39",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yMD2AY",
    },
    {
      BuildingNumber: "39",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hF2AS",
    },
    {
      BuildingNumber: "39",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vm2AK",
    },
    {
      BuildingNumber: "4",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gk2AK",
    },
    {
      BuildingNumber: "4",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9St2AK",
    },
    {
      BuildingNumber: "4",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9B82AK",
    },
    {
      BuildingNumber: "4",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yMF2AY",
    },
    {
      BuildingNumber: "4",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p82AC",
    },
    {
      BuildingNumber: "4",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nn2AC",
    },
    {
      BuildingNumber: "4",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAn2AI",
    },
    {
      BuildingNumber: "4",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yeB2AQ",
    },
    {
      BuildingNumber: "40",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40L2AS",
    },
    {
      BuildingNumber: "40",
      Street: "ASHDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjP2AQ",
    },
    {
      BuildingNumber: "40",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q82AK",
    },
    {
      BuildingNumber: "40",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kE2AS",
    },
    {
      BuildingNumber: "40",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y7l2AA",
    },
    {
      BuildingNumber: "40",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9O32AK",
    },
    {
      BuildingNumber: "40",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GB2A0",
    },
    {
      BuildingNumber: "41",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74V2AS",
    },
    {
      BuildingNumber: "41",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2o82AC",
    },
    {
      BuildingNumber: "41",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xhu2AA",
    },
    {
      BuildingNumber: "41",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7aj2AC",
    },
    {
      BuildingNumber: "41",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TK2A0",
    },
    {
      BuildingNumber: "41",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrf2AA",
    },
    {
      BuildingNumber: "41",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYZ2AY",
    },
    {
      BuildingNumber: "41",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Dl2AK",
    },
    {
      BuildingNumber: "41",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3FQ2A0",
    },
    {
      BuildingNumber: "41",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzT2AQ",
    },
    {
      BuildingNumber: "42",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UW2A0",
    },
    {
      BuildingNumber: "42",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L62AK",
    },
    {
      BuildingNumber: "42",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AH2A0",
    },
    {
      BuildingNumber: "42",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y7k2AA",
    },
    {
      BuildingNumber: "42",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4572AC",
    },
    {
      BuildingNumber: "42",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bY2AS",
    },
    {
      BuildingNumber: "42",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GZ2A0",
    },
    {
      BuildingNumber: "42",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1iN2AS",
    },
    {
      BuildingNumber: "42",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ne2AC",
    },
    {
      BuildingNumber: "43",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUP2AY",
    },
    {
      BuildingNumber: "43",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ej2AC",
    },
    {
      BuildingNumber: "43",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RW2A0",
    },
    {
      BuildingNumber: "43",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6hw2AC",
    },
    {
      BuildingNumber: "43",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EM2A0",
    },
    {
      BuildingNumber: "43",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EL2A0",
    },
    {
      BuildingNumber: "43",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yU2AS",
    },
    {
      BuildingNumber: "44",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77k2AC",
    },
    {
      BuildingNumber: "44",
      Street: "BIRCH ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Di2AK",
    },
    {
      BuildingNumber: "44",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAq2AI",
    },
    {
      BuildingNumber: "44",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ut2AK",
    },
    {
      BuildingNumber: "44",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0mK2AS",
    },
    {
      BuildingNumber: "44",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oN2AS",
    },
    {
      BuildingNumber: "44",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jz2AK",
    },
    {
      BuildingNumber: "44",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fe2AC",
    },
    {
      BuildingNumber: "44",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WT2A0",
    },
    {
      BuildingNumber: "45",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Ro2AK",
    },
    {
      BuildingNumber: "45",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MJ2A0",
    },
    {
      BuildingNumber: "45",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qe2AC",
    },
    {
      BuildingNumber: "45",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Lt2AK",
    },
    {
      BuildingNumber: "45",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWj2AI",
    },
    {
      BuildingNumber: "45",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8eu2AC",
    },
    {
      BuildingNumber: "46",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A35r2AC",
    },
    {
      BuildingNumber: "46",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MP2A0",
    },
    {
      BuildingNumber: "46",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u72AC",
    },
    {
      BuildingNumber: "46",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xAE2AY",
    },
    {
      BuildingNumber: "46",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m72AC",
    },
    {
      BuildingNumber: "46",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6dA2AS",
    },
    {
      BuildingNumber: "46",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32i2AC",
    },
    {
      BuildingNumber: "46",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqx2AA",
    },
    {
      BuildingNumber: "47",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tP2AS",
    },
    {
      BuildingNumber: "47",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YE2A0",
    },
    {
      BuildingNumber: "47",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kQ2AS",
    },
    {
      BuildingNumber: "47",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TT2A0",
    },
    {
      BuildingNumber: "48",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xbZ2AQ",
    },
    {
      BuildingNumber: "48",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A32j2AC",
    },
    {
      BuildingNumber: "48",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6zh2AC",
    },
    {
      BuildingNumber: "48",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kG2AS",
    },
    {
      BuildingNumber: "48",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0GC2A0",
    },
    {
      BuildingNumber: "48",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrU2AQ",
    },
    {
      BuildingNumber: "49",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye72AA",
    },
    {
      BuildingNumber: "49",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5kJ2AS",
    },
    {
      BuildingNumber: "49",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zev2AA",
    },
    {
      BuildingNumber: "5",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yHT2AY",
    },
    {
      BuildingNumber: "5",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y52AK",
    },
    {
      BuildingNumber: "5",
      Street: "BOND ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9sf2AC",
    },
    {
      BuildingNumber: "5",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mf2AC",
    },
    {
      BuildingNumber: "5",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8K12AK",
    },
    {
      BuildingNumber: "5",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72s2AC",
    },
    {
      BuildingNumber: "5",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsR2AQ",
    },
    {
      BuildingNumber: "5",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RY2A0",
    },
    {
      BuildingNumber: "5",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yEF2AY",
    },
    {
      BuildingNumber: "5",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6lB2AS",
    },
    {
      BuildingNumber: "5",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8qC2AS",
    },
    {
      BuildingNumber: "5",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2JT2A0",
    },
    {
      BuildingNumber: "5",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oF2AS",
    },
    {
      BuildingNumber: "5",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zP2AS",
    },
    {
      BuildingNumber: "5",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8zr2AC",
    },
    {
      BuildingNumber: "5",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vy82AA",
    },
    {
      BuildingNumber: "50",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EN2A0",
    },
    {
      BuildingNumber: "50",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m62AC",
    },
    {
      BuildingNumber: "50",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kd2AK",
    },
    {
      BuildingNumber: "50",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E62AK",
    },
    {
      BuildingNumber: "50",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Um2AK",
    },
    {
      BuildingNumber: "50",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R32AK",
    },
    {
      BuildingNumber: "51",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7al2AC",
    },
    {
      BuildingNumber: "51",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zh2AC",
    },
    {
      BuildingNumber: "51",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z282AA",
    },
    {
      BuildingNumber: "51",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TU2A0",
    },
    {
      BuildingNumber: "52",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6202AC",
    },
    {
      BuildingNumber: "52",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ko2AK",
    },
    {
      BuildingNumber: "52",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R92AK",
    },
    {
      BuildingNumber: "52",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72w2AC",
    },
    {
      BuildingNumber: "52",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Pj2AK",
    },
    {
      BuildingNumber: "53",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gl2AK",
    },
    {
      BuildingNumber: "53",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zez2AA",
    },
    {
      BuildingNumber: "53",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e42AC",
    },
    {
      BuildingNumber: "53",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xJ2AS",
    },
    {
      BuildingNumber: "54",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7am2AC",
    },
    {
      BuildingNumber: "54",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zi2AC",
    },
    {
      BuildingNumber: "54",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xC2AS",
    },
    {
      BuildingNumber: "54",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3KO2A0",
    },
    {
      BuildingNumber: "55",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5W2AQ",
    },
    {
      BuildingNumber: "55",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kj2AK",
    },
    {
      BuildingNumber: "55",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A18p2AC",
    },
    {
      BuildingNumber: "55",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77m2AC",
    },
    {
      BuildingNumber: "55",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mo2AK",
    },
    {
      BuildingNumber: "56",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2OK2A0",
    },
    {
      BuildingNumber: "56",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEz2AI",
    },
    {
      BuildingNumber: "56",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A43T2AS",
    },
    {
      BuildingNumber: "56",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7dz2AC",
    },
    {
      BuildingNumber: "57",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4oG2AS",
    },
    {
      BuildingNumber: "57",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4me2AC",
    },
    {
      BuildingNumber: "57",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4rS2AS",
    },
    {
      BuildingNumber: "57",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZS2A0",
    },
    {
      BuildingNumber: "58",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3oz2AC",
    },
    {
      BuildingNumber: "58",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qz2AK",
    },
    {
      BuildingNumber: "58",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Iz2AK",
    },
    {
      BuildingNumber: "59",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60T2AS",
    },
    {
      BuildingNumber: "59",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4562AC",
    },
    {
      BuildingNumber: "59",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrQ2AQ",
    },
    {
      BuildingNumber: "59",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1SD2A0",
    },
    {
      BuildingNumber: "6",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pJ2AS",
    },
    {
      BuildingNumber: "6",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8mx2AC",
    },
    {
      BuildingNumber: "6",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HO2A0",
    },
    {
      BuildingNumber: "6",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xmm2AA",
    },
    {
      BuildingNumber: "6",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9HZ2A0",
    },
    {
      BuildingNumber: "6",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1X22AK",
    },
    {
      BuildingNumber: "6",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zro2AA",
    },
    {
      BuildingNumber: "6",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqC2AQ",
    },
    {
      BuildingNumber: "6",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g92AC",
    },
    {
      BuildingNumber: "6",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tw2AC",
    },
    {
      BuildingNumber: "6",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PD2A0",
    },
    {
      BuildingNumber: "6",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjm2AA",
    },
    {
      BuildingNumber: "60",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ef2AK",
    },
    {
      BuildingNumber: "60",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vy92AA",
    },
    {
      BuildingNumber: "60",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vd2AK",
    },
    {
      BuildingNumber: "60",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yUQ2AY",
    },
    {
      BuildingNumber: "60",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ynr2AA",
    },
    {
      BuildingNumber: "61",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F72AK",
    },
    {
      BuildingNumber: "61",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vzU2AQ",
    },
    {
      BuildingNumber: "61",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2BO2A0",
    },
    {
      BuildingNumber: "61",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e12AC",
    },
    {
      BuildingNumber: "62",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LP2A0",
    },
    {
      BuildingNumber: "62",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Z72AK",
    },
    {
      BuildingNumber: "62",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77l2AC",
    },
    {
      BuildingNumber: "62",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOb2AI",
    },
    {
      BuildingNumber: "62",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019y4T2AQ",
    },
    {
      BuildingNumber: "63",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sl2AK",
    },
    {
      BuildingNumber: "63",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZC2AY",
    },
    {
      BuildingNumber: "63",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RV2A0",
    },
    {
      BuildingNumber: "63",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ME2A0",
    },
    {
      BuildingNumber: "64",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6wP2AS",
    },
    {
      BuildingNumber: "64",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xV62AI",
    },
    {
      BuildingNumber: "64",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wM82AI",
    },
    {
      BuildingNumber: "64",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysb2AA",
    },
    {
      BuildingNumber: "64",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5192AC",
    },
    {
      BuildingNumber: "65",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZR2A0",
    },
    {
      BuildingNumber: "65",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrj2AA",
    },
    {
      BuildingNumber: "65",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g62AC",
    },
    {
      BuildingNumber: "65",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn42AA",
    },
    {
      BuildingNumber: "65",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgN2AQ",
    },
    {
      BuildingNumber: "66",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y22AC",
    },
    {
      BuildingNumber: "66",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Z82AK",
    },
    {
      BuildingNumber: "66",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPQ2AY",
    },
    {
      BuildingNumber: "66",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7nf2AC",
    },
    {
      BuildingNumber: "66",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5U2AQ",
    },
    {
      BuildingNumber: "67",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yT2AS",
    },
    {
      BuildingNumber: "67",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOc2AI",
    },
    {
      BuildingNumber: "67",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zOp2AI",
    },
    {
      BuildingNumber: "67",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83n2AC",
    },
    {
      BuildingNumber: "67",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AF2A0",
    },
    {
      BuildingNumber: "67",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZD2A0",
    },
    {
      BuildingNumber: "68",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0812AC",
    },
    {
      BuildingNumber: "68",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wE22AI",
    },
    {
      BuildingNumber: "68",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g72AC",
    },
    {
      BuildingNumber: "68",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3sC2AS",
    },
    {
      BuildingNumber: "68",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40K2AS",
    },
    {
      BuildingNumber: "69",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsU2AQ",
    },
    {
      BuildingNumber: "69",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e52AC",
    },
    {
      BuildingNumber: "69",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UJ2A0",
    },
    {
      BuildingNumber: "69",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zYY2AY",
    },
    {
      BuildingNumber: "69",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G82AK",
    },
    {
      BuildingNumber: "69",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kA2AS",
    },
    {
      BuildingNumber: "7",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3lj2AC",
    },
    {
      BuildingNumber: "7",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6OY2A0",
    },
    {
      BuildingNumber: "7",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0G92AK",
    },
    {
      BuildingNumber: "7",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za52AA",
    },
    {
      BuildingNumber: "7",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jk2AK",
    },
    {
      BuildingNumber: "7",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jv2AK",
    },
    {
      BuildingNumber: "7",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8K2AQ",
    },
    {
      BuildingNumber: "7",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A51A2AS",
    },
    {
      BuildingNumber: "7",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fq2AK",
    },
    {
      BuildingNumber: "7",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bu2AK",
    },
    {
      BuildingNumber: "7",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vhe2AA",
    },
    {
      BuildingNumber: "7",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bU2AS",
    },
    {
      BuildingNumber: "7",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Ee2AK",
    },
    {
      BuildingNumber: "7",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ySj2AI",
    },
    {
      BuildingNumber: "70",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3de2AC",
    },
    {
      BuildingNumber: "70",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0kj2AC",
    },
    {
      BuildingNumber: "70",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ro2AK",
    },
    {
      BuildingNumber: "70",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xet2AA",
    },
    {
      BuildingNumber: "70",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEv2AI",
    },
    {
      BuildingNumber: "70",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yam2AA",
    },
    {
      BuildingNumber: "71",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VE2A0",
    },
    {
      BuildingNumber: "71",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vg42AA",
    },
    {
      BuildingNumber: "71",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6rc2AC",
    },
    {
      BuildingNumber: "71",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wU62AI",
    },
    {
      BuildingNumber: "71",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kb2AK",
    },
    {
      BuildingNumber: "72",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sW2AS",
    },
    {
      BuildingNumber: "72",
      Street: "ALEX ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rs2AK",
    },
    {
      BuildingNumber: "72",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6YF2A0",
    },
    {
      BuildingNumber: "72",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5R02AK",
    },
    {
      BuildingNumber: "72",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A09V2AS",
    },
    {
      BuildingNumber: "72",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yME2AY",
    },
    {
      BuildingNumber: "72",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vul2AA",
    },
    {
      BuildingNumber: "73",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MD2A0",
    },
    {
      BuildingNumber: "73",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5UB2A0",
    },
    {
      BuildingNumber: "73",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5qh2AC",
    },
    {
      BuildingNumber: "73",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEu2AI",
    },
    {
      BuildingNumber: "73",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zLb2AI",
    },
    {
      BuildingNumber: "73",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0MP2A0",
    },
    {
      BuildingNumber: "74",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1de2AC",
    },
    {
      BuildingNumber: "74",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjO2AQ",
    },
    {
      BuildingNumber: "74",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UI2A0",
    },
    {
      BuildingNumber: "74",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8v12AC",
    },
    {
      BuildingNumber: "74",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yan2AA",
    },
    {
      BuildingNumber: "75",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5EB2A0",
    },
    {
      BuildingNumber: "75",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L72AK",
    },
    {
      BuildingNumber: "75",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1db2AC",
    },
    {
      BuildingNumber: "75",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41u2AC",
    },
    {
      BuildingNumber: "76",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xje2AA",
    },
    {
      BuildingNumber: "76",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72y2AC",
    },
    {
      BuildingNumber: "76",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0xV2AS",
    },
    {
      BuildingNumber: "76",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGq2AI",
    },
    {
      BuildingNumber: "76",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xgO2AQ",
    },
    {
      BuildingNumber: "77",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYS2AY",
    },
    {
      BuildingNumber: "77",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LQ2A0",
    },
    {
      BuildingNumber: "77",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wnX2AQ",
    },
    {
      BuildingNumber: "77",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TQ2A0",
    },
    {
      BuildingNumber: "77",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PH2A0",
    },
    {
      BuildingNumber: "78",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2jM2AS",
    },
    {
      BuildingNumber: "78",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4QB2A0",
    },
    {
      BuildingNumber: "78",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rn2AK",
    },
    {
      BuildingNumber: "78",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5ab2AC",
    },
    {
      BuildingNumber: "78",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1tb2AC",
    },
    {
      BuildingNumber: "79",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gi2AK",
    },
    {
      BuildingNumber: "79",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2zN2AS",
    },
    {
      BuildingNumber: "79",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bq2AK",
    },
    {
      BuildingNumber: "79",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzs2AA",
    },
    {
      BuildingNumber: "79",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yao2AA",
    },
    {
      BuildingNumber: "8",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9EO2A0",
    },
    {
      BuildingNumber: "8",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hS2AS",
    },
    {
      BuildingNumber: "8",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwh2AA",
    },
    {
      BuildingNumber: "8",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sK2AS",
    },
    {
      BuildingNumber: "8",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80Z2AS",
    },
    {
      BuildingNumber: "8",
      Street: "CROSS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yxI2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yRD2AY",
    },
    {
      BuildingNumber: "8",
      Street: "GENERAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TO2A0",
    },
    {
      BuildingNumber: "8",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zqB2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019waa2AA",
    },
    {
      BuildingNumber: "8",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fp2AK",
    },
    {
      BuildingNumber: "8",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rk2AK",
    },
    {
      BuildingNumber: "8",
      Street: "SHASTA LANE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlI2AQ",
    },
    {
      BuildingNumber: "8",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0ZT2A0",
    },
    {
      BuildingNumber: "8",
      Street: "VAL ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KY2A0",
    },
    {
      BuildingNumber: "80",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41s2AC",
    },
    {
      BuildingNumber: "80",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7R82AK",
    },
    {
      BuildingNumber: "80",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjN2AQ",
    },
    {
      BuildingNumber: "80",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15g2AC",
    },
    {
      BuildingNumber: "80",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1C62AK",
    },
    {
      BuildingNumber: "81",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41t2AC",
    },
    {
      BuildingNumber: "81",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Az2AK",
    },
    {
      BuildingNumber: "81",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8LW2A0",
    },
    {
      BuildingNumber: "81",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Cj2AK",
    },
    {
      BuildingNumber: "81",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Eq2AK",
    },
    {
      BuildingNumber: "82",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PG2A0",
    },
    {
      BuildingNumber: "82",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Ss2AK",
    },
    {
      BuildingNumber: "82",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fc2AC",
    },
    {
      BuildingNumber: "82",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vma2AA",
    },
    {
      BuildingNumber: "83",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gE2AS",
    },
    {
      BuildingNumber: "83",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6I72AK",
    },
    {
      BuildingNumber: "83",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RZ2A0",
    },
    {
      BuildingNumber: "83",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l42AC",
    },
    {
      BuildingNumber: "83",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l22AC",
    },
    {
      BuildingNumber: "84",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1IX2A0",
    },
    {
      BuildingNumber: "84",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8a32AC",
    },
    {
      BuildingNumber: "84",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A51B2AS",
    },
    {
      BuildingNumber: "84",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65I2AS",
    },
    {
      BuildingNumber: "85",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5M2AQ",
    },
    {
      BuildingNumber: "85",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A72x2AC",
    },
    {
      BuildingNumber: "85",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9MQ2A0",
    },
    {
      BuildingNumber: "85",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q42AK",
    },
    {
      BuildingNumber: "85",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d62AC",
    },
    {
      BuildingNumber: "85",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z292AA",
    },
    {
      BuildingNumber: "86",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWh2AI",
    },
    {
      BuildingNumber: "86",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7XV2A0",
    },
    {
      BuildingNumber: "86",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6gK2AS",
    },
    {
      BuildingNumber: "86",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A71H2AS",
    },
    {
      BuildingNumber: "86",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5E92AK",
    },
    {
      BuildingNumber: "87",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w192AA",
    },
    {
      BuildingNumber: "87",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Zr2AK",
    },
    {
      BuildingNumber: "87",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s32AC",
    },
    {
      BuildingNumber: "87",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Dk2AK",
    },
    {
      BuildingNumber: "87",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e02AC",
    },
    {
      BuildingNumber: "88",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xWi2AI",
    },
    {
      BuildingNumber: "88",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0822AC",
    },
    {
      BuildingNumber: "88",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpy2AA",
    },
    {
      BuildingNumber: "88",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xrg2AA",
    },
    {
      BuildingNumber: "88",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7MG2A0",
    },
    {
      BuildingNumber: "89",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Np2AK",
    },
    {
      BuildingNumber: "89",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8K02AK",
    },
    {
      BuildingNumber: "89",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpz2AA",
    },
    {
      BuildingNumber: "89",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3CK2A0",
    },
    {
      BuildingNumber: "89",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn32AA",
    },
    {
      BuildingNumber: "9",
      Street: "APOLLO CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wsT2AQ",
    },
    {
      BuildingNumber: "9",
      Street: "BOND ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8ob2AC",
    },
    {
      BuildingNumber: "9",
      Street: "BORDEN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7W02AK",
    },
    {
      BuildingNumber: "9",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Uk2AK",
    },
    {
      BuildingNumber: "9",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn52AA",
    },
    {
      BuildingNumber: "9",
      Street: "FLINT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoW2AQ",
    },
    {
      BuildingNumber: "9",
      Street: "FORD ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gX2AS",
    },
    {
      BuildingNumber: "9",
      Street: "GLENDA CRES",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yap2AA",
    },
    {
      BuildingNumber: "9",
      Street: "HOMEWARD AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6jW2AS",
    },
    {
      BuildingNumber: "9",
      Street: "KEYSTONE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qw2AK",
    },
    {
      BuildingNumber: "9",
      Street: "KINGSMERE CRT",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WU2A0",
    },
    {
      BuildingNumber: "9",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bX2AS",
    },
    {
      BuildingNumber: "9",
      Street: "MCFATRIDGE RD",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGs2AI",
    },
    {
      BuildingNumber: "9",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5aZ2AS",
    },
    {
      BuildingNumber: "9",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za32AA",
    },
    {
      BuildingNumber: "9",
      Street: "SHAMROCK DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m22AC",
    },
    {
      BuildingNumber: "9",
      Street: "SKEENA ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9UT2A0",
    },
    {
      BuildingNumber: "9",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYU2AY",
    },
    {
      BuildingNumber: "90",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yEG2AY",
    },
    {
      BuildingNumber: "90",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7e32AC",
    },
    {
      BuildingNumber: "90",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mc2AC",
    },
    {
      BuildingNumber: "90",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6V02AK",
    },
    {
      BuildingNumber: "91",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8tO2AS",
    },
    {
      BuildingNumber: "91",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y12AC",
    },
    {
      BuildingNumber: "91",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7EC2A0",
    },
    {
      BuildingNumber: "91",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kf2AK",
    },
    {
      BuildingNumber: "92",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A57Z2AS",
    },
    {
      BuildingNumber: "92",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Et2AK",
    },
    {
      BuildingNumber: "92",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoU2AQ",
    },
    {
      BuildingNumber: "92",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7qs2AC",
    },
    {
      BuildingNumber: "92",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYQ2AY",
    },
    {
      BuildingNumber: "93",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3122AC",
    },
    {
      BuildingNumber: "93",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4552AC",
    },
    {
      BuildingNumber: "93",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sX2AS",
    },
    {
      BuildingNumber: "93",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlM2AQ",
    },
    {
      BuildingNumber: "93",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rr2AK",
    },
    {
      BuildingNumber: "93",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ju2AK",
    },
    {
      BuildingNumber: "94",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1C92AK",
    },
    {
      BuildingNumber: "94",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9W52AK",
    },
    {
      BuildingNumber: "94",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Kc2AK",
    },
    {
      BuildingNumber: "94",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lw2AC",
    },
    {
      BuildingNumber: "95",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w4R2AQ",
    },
    {
      BuildingNumber: "95",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qb2AC",
    },
    {
      BuildingNumber: "95",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7u92AC",
    },
    {
      BuildingNumber: "95",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6N22AK",
    },
    {
      BuildingNumber: "95",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yPS2AY",
    },
    {
      BuildingNumber: "95",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Es2AK",
    },
    {
      BuildingNumber: "96",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4cz2AC",
    },
    {
      BuildingNumber: "96",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6eh2AC",
    },
    {
      BuildingNumber: "96",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6ba2AC",
    },
    {
      BuildingNumber: "96",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8wc2AC",
    },
    {
      BuildingNumber: "96",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xs2AK",
    },
    {
      BuildingNumber: "97",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yuD2AQ",
    },
    {
      BuildingNumber: "97",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Va2AK",
    },
    {
      BuildingNumber: "97",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ni2AC",
    },
    {
      BuildingNumber: "97",
      Street: "MELROSE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yX2AS",
    },
    {
      BuildingNumber: "97",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A91R2AS",
    },
    {
      BuildingNumber: "97",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x8b2AA",
    },
    {
      BuildingNumber: "97",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A88c2AC",
    },
    {
      BuildingNumber: "98",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qy2AK",
    },
    {
      BuildingNumber: "98",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6l92AC",
    },
    {
      BuildingNumber: "98",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8ji2AC",
    },
    {
      BuildingNumber: "98",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8mv2AC",
    },
    {
      BuildingNumber: "99",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjM2AQ",
    },
    {
      BuildingNumber: "99",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yZE2AY",
    },
    {
      BuildingNumber: "99",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xF12AI",
    },
    {
      BuildingNumber: "99",
      Street: "ROSEDALE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8yD2AS",
    },
    {
      BuildingNumber: "99",
      Street: "SCHOOL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7sW2AS",
    },
    {
      BuildingNumber: "99",
      Street: "SUNNYBRAE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZE2A0",
    },
    {
      BuildingNumber: "9A",
      Street: "CENTRAL AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A68S2AS",
    },
    {
      BuildingNumber: "10",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yxK2AQ",
    },
    {
      BuildingNumber: "11",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAu2AI",
    },
    {
      BuildingNumber: "12",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bt2AK",
    },
    {
      BuildingNumber: "13",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xDI2AY",
    },
    {
      BuildingNumber: "14",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T52AK",
    },
    {
      BuildingNumber: "15",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1f72AC",
    },
    {
      BuildingNumber: "16",
      Street: "DAWN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6DF2A0",
    },
    {
      BuildingNumber: "16",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ct2AK",
    },
    {
      BuildingNumber: "18",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xD2AS",
    },
    {
      BuildingNumber: "2",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jo2AK",
    },
    {
      BuildingNumber: "22",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yuF2AQ",
    },
    {
      BuildingNumber: "25",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ72AI",
    },
    {
      BuildingNumber: "28",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6mj2AC",
    },
    {
      BuildingNumber: "30",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xbc2AA",
    },
    {
      BuildingNumber: "4",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A29i2AC",
    },
    {
      BuildingNumber: "4",
      Street: "MAPLE ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A26W2AS",
    },
    {
      BuildingNumber: "45",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9JD2A0",
    },
    {
      BuildingNumber: "47",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9cZ2AS",
    },
    {
      BuildingNumber: "48",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4mb2AC",
    },
    {
      BuildingNumber: "48",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wE42AI",
    },
    {
      BuildingNumber: "49",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQR2AY",
    },
    {
      BuildingNumber: "50",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjg2AA",
    },
    {
      BuildingNumber: "50",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ER2A0",
    },
    {
      BuildingNumber: "51",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1lT2AS",
    },
    {
      BuildingNumber: "52",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3X82AK",
    },
    {
      BuildingNumber: "53",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3XF2A0",
    },
    {
      BuildingNumber: "55",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Z02AK",
    },
    {
      BuildingNumber: "58",
      Street: "EVANS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9kc2AC",
    },
    {
      BuildingNumber: "58",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ky2AC",
    },
    {
      BuildingNumber: "6",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9Cn2AK",
    },
    {
      BuildingNumber: "60",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEs2AI",
    },
    {
      BuildingNumber: "62",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pM2AS",
    },
    {
      BuildingNumber: "65",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1AW2A0",
    },
    {
      BuildingNumber: "69",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4TI2A0",
    },
    {
      BuildingNumber: "7",
      Street: "DAWN ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bR2AS",
    },
    {
      BuildingNumber: "70",
      Street: "LACEWOOD DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1ws2AC",
    },
    {
      BuildingNumber: "70",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s62AC",
    },
    {
      BuildingNumber: "71",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hB2AS",
    },
    {
      BuildingNumber: "73",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dK2AS",
    },
    {
      BuildingNumber: "74",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6DI2A0",
    },
    {
      BuildingNumber: "75",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5O2AQ",
    },
    {
      BuildingNumber: "76",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fu2AK",
    },
    {
      BuildingNumber: "77",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pN2AS",
    },
    {
      BuildingNumber: "78",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9ZK2A0",
    },
    {
      BuildingNumber: "79",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5xB2AS",
    },
    {
      BuildingNumber: "8",
      Street: "BERTS DR",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6y52AC",
    },
    {
      BuildingNumber: "80",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8NA2A0",
    },
    {
      BuildingNumber: "81",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7fZ2AS",
    },
    {
      BuildingNumber: "82",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0T22AK",
    },
    {
      BuildingNumber: "83",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tu2AC",
    },
    {
      BuildingNumber: "86",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HT2A0",
    },
    {
      BuildingNumber: "88",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrX2AQ",
    },
    {
      BuildingNumber: "9",
      Street: "TITUS ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9aw2AC",
    },
    {
      BuildingNumber: "90",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9fm2AC",
    },
    {
      BuildingNumber: "92",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9372AC",
    },
    {
      BuildingNumber: "94",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A9eA2AS",
    },
    {
      BuildingNumber: "100",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yvj2AA",
    },
    {
      BuildingNumber: "100",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tF2AS",
    },
    {
      BuildingNumber: "101",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zc2AC",
    },
    {
      BuildingNumber: "101",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bW2AS",
    },
    {
      BuildingNumber: "102",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vmZ2AQ",
    },
    {
      BuildingNumber: "102",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwd2AA",
    },
    {
      BuildingNumber: "103",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DT2A0",
    },
    {
      BuildingNumber: "104",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T72AK",
    },
    {
      BuildingNumber: "104",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gT2AS",
    },
    {
      BuildingNumber: "105",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ynq2AA",
    },
    {
      BuildingNumber: "107",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2wA2AS",
    },
    {
      BuildingNumber: "108",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1AX2A0",
    },
    {
      BuildingNumber: "109",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40J2AS",
    },
    {
      BuildingNumber: "110",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5E2AQ",
    },
    {
      BuildingNumber: "111",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fl2AK",
    },
    {
      BuildingNumber: "111",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xp2AK",
    },
    {
      BuildingNumber: "112",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrR2AQ",
    },
    {
      BuildingNumber: "112",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3k92AC",
    },
    {
      BuildingNumber: "113",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HN2A0",
    },
    {
      BuildingNumber: "113",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5nU2AS",
    },
    {
      BuildingNumber: "114",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sw2AK",
    },
    {
      BuildingNumber: "114",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ry2AK",
    },
    {
      BuildingNumber: "114",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sQ2AS",
    },
    {
      BuildingNumber: "115",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zeu2AA",
    },
    {
      BuildingNumber: "115",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w4Q2AQ",
    },
    {
      BuildingNumber: "115",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8TZ2A0",
    },
    {
      BuildingNumber: "116",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A49y2AC",
    },
    {
      BuildingNumber: "116",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOY2AY",
    },
    {
      BuildingNumber: "116",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bO2AS",
    },
    {
      BuildingNumber: "117",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7E92AK",
    },
    {
      BuildingNumber: "117",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7662AC",
    },
    {
      BuildingNumber: "118",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8J2AQ",
    },
    {
      BuildingNumber: "118",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oR2AS",
    },
    {
      BuildingNumber: "118",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Mz2AK",
    },
    {
      BuildingNumber: "119",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cv2AK",
    },
    {
      BuildingNumber: "119",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A79K2AS",
    },
    {
      BuildingNumber: "119",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sx2AK",
    },
    {
      BuildingNumber: "120",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41r2AC",
    },
    {
      BuildingNumber: "120",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gg2AK",
    },
    {
      BuildingNumber: "120",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3XB2A0",
    },
    {
      BuildingNumber: "121",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sv2AK",
    },
    {
      BuildingNumber: "121",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xhv2AA",
    },
    {
      BuildingNumber: "122",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46j2AC",
    },
    {
      BuildingNumber: "122",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEt2AI",
    },
    {
      BuildingNumber: "122",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yg2AK",
    },
    {
      BuildingNumber: "123",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Aw2AK",
    },
    {
      BuildingNumber: "123",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d42AC",
    },
    {
      BuildingNumber: "124",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65H2AS",
    },
    {
      BuildingNumber: "124",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46g2AC",
    },
    {
      BuildingNumber: "124",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AD2A0",
    },
    {
      BuildingNumber: "125",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjK2AQ",
    },
    {
      BuildingNumber: "125",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GU2A0",
    },
    {
      BuildingNumber: "126",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qa2AC",
    },
    {
      BuildingNumber: "126",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A79J2AS",
    },
    {
      BuildingNumber: "126",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l02AC",
    },
    {
      BuildingNumber: "127",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yvk2AA",
    },
    {
      BuildingNumber: "127",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HP2A0",
    },
    {
      BuildingNumber: "128",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vui2AA",
    },
    {
      BuildingNumber: "128",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yix2AA",
    },
    {
      BuildingNumber: "128",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41o2AC",
    },
    {
      BuildingNumber: "129",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3102AC",
    },
    {
      BuildingNumber: "129",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Ni2AK",
    },
    {
      BuildingNumber: "130",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qQ2AS",
    },
    {
      BuildingNumber: "130",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3k82AC",
    },
    {
      BuildingNumber: "131",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yiw2AA",
    },
    {
      BuildingNumber: "132",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41q2AC",
    },
    {
      BuildingNumber: "132",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41w2AC",
    },
    {
      BuildingNumber: "132",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A48J2AS",
    },
    {
      BuildingNumber: "133",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Wc2AK",
    },
    {
      BuildingNumber: "134",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn12AA",
    },
    {
      BuildingNumber: "134",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAo2AI",
    },
    {
      BuildingNumber: "135",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ke2AK",
    },
    {
      BuildingNumber: "135",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6rd2AC",
    },
    {
      BuildingNumber: "136",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zb2AC",
    },
    {
      BuildingNumber: "136",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63e2AC",
    },
    {
      BuildingNumber: "137",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ52AI",
    },
    {
      BuildingNumber: "137",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0xW2AS",
    },
    {
      BuildingNumber: "138",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eA2AS",
    },
    {
      BuildingNumber: "138",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Ve2AK",
    },
    {
      BuildingNumber: "139",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8II2A0",
    },
    {
      BuildingNumber: "139",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83m2AC",
    },
    {
      BuildingNumber: "140",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77q2AC",
    },
    {
      BuildingNumber: "140",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ee2AC",
    },
    {
      BuildingNumber: "140",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15f2AC",
    },
    {
      BuildingNumber: "141",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F32AK",
    },
    {
      BuildingNumber: "142",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ed2AC",
    },
    {
      BuildingNumber: "142",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sO2AS",
    },
    {
      BuildingNumber: "143",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4za2AC",
    },
    {
      BuildingNumber: "144",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zi72AA",
    },
    {
      BuildingNumber: "144",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qx2AK",
    },
    {
      BuildingNumber: "145",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85P2AS",
    },
    {
      BuildingNumber: "146",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqy2AA",
    },
    {
      BuildingNumber: "146",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jt2AK",
    },
    {
      BuildingNumber: "147",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sh2AK",
    },
    {
      BuildingNumber: "147",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UZ2A0",
    },
    {
      BuildingNumber: "148",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5dq2AC",
    },
    {
      BuildingNumber: "148",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GV2A0",
    },
    {
      BuildingNumber: "149",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60Q2AS",
    },
    {
      BuildingNumber: "149",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrp2AA",
    },
    {
      BuildingNumber: "150",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wXV2AY",
    },
    {
      BuildingNumber: "150",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pH2AS",
    },
    {
      BuildingNumber: "151",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DR2A0",
    },
    {
      BuildingNumber: "151",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DS2A0",
    },
    {
      BuildingNumber: "152",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bS2AS",
    },
    {
      BuildingNumber: "152",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g82AC",
    },
    {
      BuildingNumber: "153",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS72AI",
    },
    {
      BuildingNumber: "153",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8IH2A0",
    },
    {
      BuildingNumber: "154",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bp2AK",
    },
    {
      BuildingNumber: "154",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qw2AK",
    },
    {
      BuildingNumber: "155",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Jh2AK",
    },
    {
      BuildingNumber: "155",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p62AC",
    },
    {
      BuildingNumber: "156",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85O2AS",
    },
    {
      BuildingNumber: "156",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xL2AS",
    },
    {
      BuildingNumber: "157",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1tZ2AS",
    },
    {
      BuildingNumber: "157",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WV2A0",
    },
    {
      BuildingNumber: "158",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jl2AK",
    },
    {
      BuildingNumber: "167",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6hv2AC",
    },
    {
      BuildingNumber: "17",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gU2AS",
    },
    {
      BuildingNumber: "175",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Rx2AK",
    },
    {
      BuildingNumber: "177",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kR2AS",
    },
    {
      BuildingNumber: "179",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Oj2AK",
    },
    {
      BuildingNumber: "18",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5D2AQ",
    },
    {
      BuildingNumber: "181",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za22AA",
    },
    {
      BuildingNumber: "183",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8QL2A0",
    },
    {
      BuildingNumber: "184",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8702AC",
    },
    {
      BuildingNumber: "185",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oQ2AS",
    },
    {
      BuildingNumber: "186",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rp2AK",
    },
    {
      BuildingNumber: "187",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s12AC",
    },
    {
      BuildingNumber: "188",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn02AA",
    },
    {
      BuildingNumber: "189",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8N72AK",
    },
    {
      BuildingNumber: "19",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6We2AK",
    },
    {
      BuildingNumber: "190",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yV2AS",
    },
    {
      BuildingNumber: "191",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41p2AC",
    },
    {
      BuildingNumber: "192",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nK2AS",
    },
    {
      BuildingNumber: "194",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4GO2A0",
    },
    {
      BuildingNumber: "195",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F42AK",
    },
    {
      BuildingNumber: "196",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60R2AS",
    },
    {
      BuildingNumber: "198",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WW2A0",
    },
    {
      BuildingNumber: "199",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63f2AC",
    },
    {
      BuildingNumber: "200",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQQ2AY",
    },
    {
      BuildingNumber: "201",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlL2AQ",
    },
    {
      BuildingNumber: "202",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rm2AK",
    },
    {
      BuildingNumber: "203",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KX2A0",
    },
    {
      BuildingNumber: "204",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5642AC",
    },
    {
      BuildingNumber: "205",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8LV2A0",
    },
    {
      BuildingNumber: "206",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RX2A0",
    },
    {
      BuildingNumber: "207",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ua2AK",
    },
    {
      BuildingNumber: "209",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjj2AA",
    },
    {
      BuildingNumber: "209",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7CY2A0",
    },
    {
      BuildingNumber: "210",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjL2AQ",
    },
    {
      BuildingNumber: "211",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye82AA",
    },
    {
      BuildingNumber: "213",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2pd2AC",
    },
    {
      BuildingNumber: "214",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pI2AS",
    },
    {
      BuildingNumber: "215",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8bd2AC",
    },
    {
      BuildingNumber: "216",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A10i2AC",
    },
    {
      BuildingNumber: "217",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vn2AK",
    },
    {
      BuildingNumber: "218",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hT2AS",
    },
    {
      BuildingNumber: "219",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A23J2AS",
    },
    {
      BuildingNumber: "220",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzp2AA",
    },
    {
      BuildingNumber: "221",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yRA2AY",
    },
    {
      BuildingNumber: "222",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dF2AS",
    },
    {
      BuildingNumber: "223",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wkP2AQ",
    },
    {
      BuildingNumber: "224",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fr2AK",
    },
    {
      BuildingNumber: "225",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zey2AA",
    },
    {
      BuildingNumber: "226",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p72AC",
    },
    {
      BuildingNumber: "227",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mq2AK",
    },
    {
      BuildingNumber: "228",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Si2AK",
    },
    {
      BuildingNumber: "230",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8a12AC",
    },
    {
      BuildingNumber: "232",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZB2A0",
    },
    {
      BuildingNumber: "234",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WX2A0",
    },
    {
      BuildingNumber: "236",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41x2AC",
    },
    {
      BuildingNumber: "238",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8YP2A0",
    },
    {
      BuildingNumber: "240",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80Y2AS",
    },
    {
      BuildingNumber: "242",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TD2A0",
    },
    {
      BuildingNumber: "244",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sP2AS",
    },
    {
      BuildingNumber: "246",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m42AC",
    },
    {
      BuildingNumber: "248",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gG2AS",
    },
    {
      BuildingNumber: "25",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s02AC",
    },
    {
      BuildingNumber: "250",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mc2AK",
    },
    {
      BuildingNumber: "252",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LN2A0",
    },
    {
      BuildingNumber: "254",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Wn2AK",
    },
    {
      BuildingNumber: "256",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1ta2AC",
    },
    {
      BuildingNumber: "258",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vx2AK",
    },
    {
      BuildingNumber: "260",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vg2AK",
    },
    {
      BuildingNumber: "264",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zd2AC",
    },
    {
      BuildingNumber: "266",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGp2AI",
    },
    {
      BuildingNumber: "27",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65D2AS",
    },
    {
      BuildingNumber: "28",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UY2A0",
    },
    {
      BuildingNumber: "32",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m32AC",
    },
    {
      BuildingNumber: "34",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2wB2AS",
    },
    {
      BuildingNumber: "36",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vw2AK",
    },
    {
      BuildingNumber: "38",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yXe2AI",
    },
    {
      BuildingNumber: "40",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3112AC",
    },
    {
      BuildingNumber: "45",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpx2AA",
    },
    {
      BuildingNumber: "47",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4hk2AC",
    },
    {
      BuildingNumber: "48",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ub2AK",
    },
    {
      BuildingNumber: "49",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zji2AA",
    },
    {
      BuildingNumber: "50",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3sB2AS",
    },
    {
      BuildingNumber: "51",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46i2AC",
    },
    {
      BuildingNumber: "52",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yi2AK",
    },
    {
      BuildingNumber: "53",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5ls2AC",
    },
    {
      BuildingNumber: "53",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQO2AY",
    },
    {
      BuildingNumber: "54",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjh2AA",
    },
    {
      BuildingNumber: "55",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46h2AC",
    },
    {
      BuildingNumber: "56",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4GP2A0",
    },
    {
      BuildingNumber: "57",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoS2AQ",
    },
    {
      BuildingNumber: "58",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ri2AK",
    },
    {
      BuildingNumber: "59",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bT2AS",
    },
    {
      BuildingNumber: "60",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQR2AY",
    },
    {
      BuildingNumber: "61",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zex2AA",
    },
    {
      BuildingNumber: "62",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8712AC",
    },
    {
      BuildingNumber: "63",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYN2AY",
    },
    {
      BuildingNumber: "64",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T62AK",
    },
    {
      BuildingNumber: "65",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L22AK",
    },
    {
      BuildingNumber: "66",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bU2AS",
    },
    {
      BuildingNumber: "67",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TR2A0",
    },
    {
      BuildingNumber: "68",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye92AA",
    },
    {
      BuildingNumber: "69",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwf2AA",
    },
    {
      BuildingNumber: "70",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hC2AS",
    },
    {
      BuildingNumber: "71",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8er2AC",
    },
    {
      BuildingNumber: "72",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5PI2A0",
    },
    {
      BuildingNumber: "73",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwe2AA",
    },
    {
      BuildingNumber: "74",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A21e2AC",
    },
    {
      BuildingNumber: "75",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0kh2AC",
    },
    {
      BuildingNumber: "76",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysW2AQ",
    },
    {
      BuildingNumber: "76",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Rz2AK",
    },
    {
      BuildingNumber: "77",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6gJ2AS",
    },
    {
      BuildingNumber: "77",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T82AK",
    },
    {
      BuildingNumber: "78",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2eR2AS",
    },
    {
      BuildingNumber: "78",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7672AC",
    },
    {
      BuildingNumber: "79",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8L2AQ",
    },
    {
      BuildingNumber: "79",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1jx2AC",
    },
    {
      BuildingNumber: "80",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5652AC",
    },
    {
      BuildingNumber: "80",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tv2AC",
    },
    {
      BuildingNumber: "81",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS52AI",
    },
    {
      BuildingNumber: "81",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KU2A0",
    },
    {
      BuildingNumber: "82",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vf2AK",
    },
    {
      BuildingNumber: "82",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PE2A0",
    },
    {
      BuildingNumber: "83",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lt2AC",
    },
    {
      BuildingNumber: "83",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Hf2AK",
    },
    {
      BuildingNumber: "83",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gF2AS",
    },
    {
      BuildingNumber: "84",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q52AK",
    },
    {
      BuildingNumber: "84",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qv2AK",
    },
    {
      BuildingNumber: "85",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDw2AI",
    },
    {
      BuildingNumber: "86",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RT2A0",
    },
    {
      BuildingNumber: "86",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y62AK",
    },
    {
      BuildingNumber: "87",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5S2AQ",
    },
    {
      BuildingNumber: "87",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ok2AK",
    },
    {
      BuildingNumber: "87",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GW2A0",
    },
    {
      BuildingNumber: "88",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuh2AA",
    },
    {
      BuildingNumber: "88",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQP2AY",
    },
    {
      BuildingNumber: "89",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5R2AQ",
    },
    {
      BuildingNumber: "89",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Z12AK",
    },
    {
      BuildingNumber: "90",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77i2AC",
    },
    {
      BuildingNumber: "90",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7CX2A0",
    },
    {
      BuildingNumber: "91",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1dc2AC",
    },
    {
      BuildingNumber: "91",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQN2AY",
    },
    {
      BuildingNumber: "92",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VB2A0",
    },
    {
      BuildingNumber: "92",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g32AC",
    },
    {
      BuildingNumber: "93",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Av2AK",
    },
    {
      BuildingNumber: "94",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ62AI",
    },
    {
      BuildingNumber: "94",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x6p2AA",
    },
    {
      BuildingNumber: "95",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77j2AC",
    },
    {
      BuildingNumber: "95",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4wL2AS",
    },
    {
      BuildingNumber: "96",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y42AK",
    },
    {
      BuildingNumber: "96",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wu02AA",
    },
    {
      BuildingNumber: "97",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UK2A0",
    },
    {
      BuildingNumber: "97",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74U2AS",
    },
    {
      BuildingNumber: "98",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ef2AC",
    },
    {
      BuildingNumber: "98",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kS2AS",
    },
    {
      BuildingNumber: "99",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOZ2AY",
    },
    {
      BuildingNumber: "99",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kD2AS",
    },
    {
      BuildingNumber: "100",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yvj2AA",
    },
    {
      BuildingNumber: "100",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6tF2AS",
    },
    {
      BuildingNumber: "101",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zc2AC",
    },
    {
      BuildingNumber: "101",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6bW2AS",
    },
    {
      BuildingNumber: "102",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vmZ2AQ",
    },
    {
      BuildingNumber: "102",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwd2AA",
    },
    {
      BuildingNumber: "103",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DT2A0",
    },
    {
      BuildingNumber: "104",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T72AK",
    },
    {
      BuildingNumber: "104",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gT2AS",
    },
    {
      BuildingNumber: "105",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ynq2AA",
    },
    {
      BuildingNumber: "107",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2wA2AS",
    },
    {
      BuildingNumber: "108",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1AX2A0",
    },
    {
      BuildingNumber: "109",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A40J2AS",
    },
    {
      BuildingNumber: "110",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5E2AQ",
    },
    {
      BuildingNumber: "111",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fl2AK",
    },
    {
      BuildingNumber: "111",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Xp2AK",
    },
    {
      BuildingNumber: "112",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vrR2AQ",
    },
    {
      BuildingNumber: "112",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3k92AC",
    },
    {
      BuildingNumber: "113",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HN2A0",
    },
    {
      BuildingNumber: "113",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5nU2AS",
    },
    {
      BuildingNumber: "114",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sw2AK",
    },
    {
      BuildingNumber: "114",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ry2AK",
    },
    {
      BuildingNumber: "114",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sQ2AS",
    },
    {
      BuildingNumber: "115",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zeu2AA",
    },
    {
      BuildingNumber: "115",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019w4Q2AQ",
    },
    {
      BuildingNumber: "115",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8TZ2A0",
    },
    {
      BuildingNumber: "116",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A49y2AC",
    },
    {
      BuildingNumber: "116",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOY2AY",
    },
    {
      BuildingNumber: "116",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bO2AS",
    },
    {
      BuildingNumber: "117",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7E92AK",
    },
    {
      BuildingNumber: "117",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7662AC",
    },
    {
      BuildingNumber: "118",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8J2AQ",
    },
    {
      BuildingNumber: "118",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oR2AS",
    },
    {
      BuildingNumber: "118",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Mz2AK",
    },
    {
      BuildingNumber: "119",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Cv2AK",
    },
    {
      BuildingNumber: "119",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A79K2AS",
    },
    {
      BuildingNumber: "119",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sx2AK",
    },
    {
      BuildingNumber: "120",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41r2AC",
    },
    {
      BuildingNumber: "120",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Gg2AK",
    },
    {
      BuildingNumber: "120",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3XB2A0",
    },
    {
      BuildingNumber: "121",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Sv2AK",
    },
    {
      BuildingNumber: "121",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xhv2AA",
    },
    {
      BuildingNumber: "122",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46j2AC",
    },
    {
      BuildingNumber: "122",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xEt2AI",
    },
    {
      BuildingNumber: "122",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yg2AK",
    },
    {
      BuildingNumber: "123",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Aw2AK",
    },
    {
      BuildingNumber: "123",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6d42AC",
    },
    {
      BuildingNumber: "124",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65H2AS",
    },
    {
      BuildingNumber: "124",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46g2AC",
    },
    {
      BuildingNumber: "124",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8AD2A0",
    },
    {
      BuildingNumber: "125",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjK2AQ",
    },
    {
      BuildingNumber: "125",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GU2A0",
    },
    {
      BuildingNumber: "126",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3qa2AC",
    },
    {
      BuildingNumber: "126",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A79J2AS",
    },
    {
      BuildingNumber: "126",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4l02AC",
    },
    {
      BuildingNumber: "127",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yvk2AA",
    },
    {
      BuildingNumber: "127",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7HP2A0",
    },
    {
      BuildingNumber: "128",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vui2AA",
    },
    {
      BuildingNumber: "128",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yix2AA",
    },
    {
      BuildingNumber: "128",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41o2AC",
    },
    {
      BuildingNumber: "129",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3102AC",
    },
    {
      BuildingNumber: "129",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Ni2AK",
    },
    {
      BuildingNumber: "130",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1qQ2AS",
    },
    {
      BuildingNumber: "130",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3k82AC",
    },
    {
      BuildingNumber: "131",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yiw2AA",
    },
    {
      BuildingNumber: "132",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41q2AC",
    },
    {
      BuildingNumber: "132",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41w2AC",
    },
    {
      BuildingNumber: "132",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A48J2AS",
    },
    {
      BuildingNumber: "133",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Wc2AK",
    },
    {
      BuildingNumber: "134",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn12AA",
    },
    {
      BuildingNumber: "134",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wAo2AI",
    },
    {
      BuildingNumber: "135",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Ke2AK",
    },
    {
      BuildingNumber: "135",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6rd2AC",
    },
    {
      BuildingNumber: "136",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zb2AC",
    },
    {
      BuildingNumber: "136",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63e2AC",
    },
    {
      BuildingNumber: "137",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ52AI",
    },
    {
      BuildingNumber: "137",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0xW2AS",
    },
    {
      BuildingNumber: "138",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0eA2AS",
    },
    {
      BuildingNumber: "138",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Ve2AK",
    },
    {
      BuildingNumber: "139",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8II2A0",
    },
    {
      BuildingNumber: "139",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A83m2AC",
    },
    {
      BuildingNumber: "140",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77q2AC",
    },
    {
      BuildingNumber: "140",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ee2AC",
    },
    {
      BuildingNumber: "140",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A15f2AC",
    },
    {
      BuildingNumber: "141",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F32AK",
    },
    {
      BuildingNumber: "142",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ed2AC",
    },
    {
      BuildingNumber: "142",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sO2AS",
    },
    {
      BuildingNumber: "143",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4za2AC",
    },
    {
      BuildingNumber: "144",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zi72AA",
    },
    {
      BuildingNumber: "144",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qx2AK",
    },
    {
      BuildingNumber: "145",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85P2AS",
    },
    {
      BuildingNumber: "146",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yqy2AA",
    },
    {
      BuildingNumber: "146",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Jt2AK",
    },
    {
      BuildingNumber: "147",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Sh2AK",
    },
    {
      BuildingNumber: "147",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UZ2A0",
    },
    {
      BuildingNumber: "148",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5dq2AC",
    },
    {
      BuildingNumber: "148",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GV2A0",
    },
    {
      BuildingNumber: "149",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60Q2AS",
    },
    {
      BuildingNumber: "149",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zrp2AA",
    },
    {
      BuildingNumber: "150",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wXV2AY",
    },
    {
      BuildingNumber: "150",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pH2AS",
    },
    {
      BuildingNumber: "151",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DR2A0",
    },
    {
      BuildingNumber: "151",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8DS2A0",
    },
    {
      BuildingNumber: "152",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bS2AS",
    },
    {
      BuildingNumber: "152",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g82AC",
    },
    {
      BuildingNumber: "153",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS72AI",
    },
    {
      BuildingNumber: "153",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8IH2A0",
    },
    {
      BuildingNumber: "154",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Bp2AK",
    },
    {
      BuildingNumber: "154",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Qw2AK",
    },
    {
      BuildingNumber: "155",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Jh2AK",
    },
    {
      BuildingNumber: "155",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p62AC",
    },
    {
      BuildingNumber: "156",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A85O2AS",
    },
    {
      BuildingNumber: "156",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7xL2AS",
    },
    {
      BuildingNumber: "157",
      Street: "FREDERICK AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1tZ2AS",
    },
    {
      BuildingNumber: "157",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WV2A0",
    },
    {
      BuildingNumber: "158",
      Street: "RUFUS AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Jl2AK",
    },
    {
      BuildingNumber: "167",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6hv2AC",
    },
    {
      BuildingNumber: "17",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8gU2AS",
    },
    {
      BuildingNumber: "175",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Rx2AK",
    },
    {
      BuildingNumber: "177",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kR2AS",
    },
    {
      BuildingNumber: "179",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Oj2AK",
    },
    {
      BuildingNumber: "18",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x5D2AQ",
    },
    {
      BuildingNumber: "181",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019za22AA",
    },
    {
      BuildingNumber: "183",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8QL2A0",
    },
    {
      BuildingNumber: "184",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8702AC",
    },
    {
      BuildingNumber: "185",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6oQ2AS",
    },
    {
      BuildingNumber: "186",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6Rp2AK",
    },
    {
      BuildingNumber: "187",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s12AC",
    },
    {
      BuildingNumber: "188",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zn02AA",
    },
    {
      BuildingNumber: "189",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8N72AK",
    },
    {
      BuildingNumber: "19",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6We2AK",
    },
    {
      BuildingNumber: "190",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1yV2AS",
    },
    {
      BuildingNumber: "191",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41p2AC",
    },
    {
      BuildingNumber: "192",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3nK2AS",
    },
    {
      BuildingNumber: "194",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4GO2A0",
    },
    {
      BuildingNumber: "195",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8F42AK",
    },
    {
      BuildingNumber: "196",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A60R2AS",
    },
    {
      BuildingNumber: "198",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WW2A0",
    },
    {
      BuildingNumber: "199",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A63f2AC",
    },
    {
      BuildingNumber: "200",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQQ2AY",
    },
    {
      BuildingNumber: "201",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zlL2AQ",
    },
    {
      BuildingNumber: "202",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Rm2AK",
    },
    {
      BuildingNumber: "203",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KX2A0",
    },
    {
      BuildingNumber: "204",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5642AC",
    },
    {
      BuildingNumber: "205",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8LV2A0",
    },
    {
      BuildingNumber: "206",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RX2A0",
    },
    {
      BuildingNumber: "207",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ua2AK",
    },
    {
      BuildingNumber: "209",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjj2AA",
    },
    {
      BuildingNumber: "209",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7CY2A0",
    },
    {
      BuildingNumber: "210",
      Street: "CORONATION AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vjL2AQ",
    },
    {
      BuildingNumber: "211",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye82AA",
    },
    {
      BuildingNumber: "213",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2pd2AC",
    },
    {
      BuildingNumber: "214",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7pI2AS",
    },
    {
      BuildingNumber: "215",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8bd2AC",
    },
    {
      BuildingNumber: "216",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A10i2AC",
    },
    {
      BuildingNumber: "217",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Vn2AK",
    },
    {
      BuildingNumber: "218",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0hT2AS",
    },
    {
      BuildingNumber: "219",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A23J2AS",
    },
    {
      BuildingNumber: "220",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zzp2AA",
    },
    {
      BuildingNumber: "221",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yRA2AY",
    },
    {
      BuildingNumber: "222",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8dF2AS",
    },
    {
      BuildingNumber: "223",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wkP2AQ",
    },
    {
      BuildingNumber: "224",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Fr2AK",
    },
    {
      BuildingNumber: "225",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zey2AA",
    },
    {
      BuildingNumber: "226",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5p72AC",
    },
    {
      BuildingNumber: "227",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Mq2AK",
    },
    {
      BuildingNumber: "228",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Si2AK",
    },
    {
      BuildingNumber: "230",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8a12AC",
    },
    {
      BuildingNumber: "232",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7ZB2A0",
    },
    {
      BuildingNumber: "234",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4WX2A0",
    },
    {
      BuildingNumber: "236",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A41x2AC",
    },
    {
      BuildingNumber: "238",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8YP2A0",
    },
    {
      BuildingNumber: "240",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A80Y2AS",
    },
    {
      BuildingNumber: "242",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2TD2A0",
    },
    {
      BuildingNumber: "244",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5sP2AS",
    },
    {
      BuildingNumber: "246",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m42AC",
    },
    {
      BuildingNumber: "248",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gG2AS",
    },
    {
      BuildingNumber: "25",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1s02AC",
    },
    {
      BuildingNumber: "250",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2Mc2AK",
    },
    {
      BuildingNumber: "252",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6LN2A0",
    },
    {
      BuildingNumber: "254",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Wn2AK",
    },
    {
      BuildingNumber: "256",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1ta2AC",
    },
    {
      BuildingNumber: "258",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vx2AK",
    },
    {
      BuildingNumber: "260",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vg2AK",
    },
    {
      BuildingNumber: "264",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4zd2AC",
    },
    {
      BuildingNumber: "266",
      Street: "MAIN AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zGp2AI",
    },
    {
      BuildingNumber: "27",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A65D2AS",
    },
    {
      BuildingNumber: "28",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0UY2A0",
    },
    {
      BuildingNumber: "32",
      Street: "HILLCREST ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7m32AC",
    },
    {
      BuildingNumber: "34",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2wB2AS",
    },
    {
      BuildingNumber: "36",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Vw2AK",
    },
    {
      BuildingNumber: "38",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019yXe2AI",
    },
    {
      BuildingNumber: "40",
      Street: "WILLETT ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3112AC",
    },
    {
      BuildingNumber: "45",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xpx2AA",
    },
    {
      BuildingNumber: "47",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4hk2AC",
    },
    {
      BuildingNumber: "48",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Ub2AK",
    },
    {
      BuildingNumber: "49",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zji2AA",
    },
    {
      BuildingNumber: "50",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3sB2AS",
    },
    {
      BuildingNumber: "51",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46i2AC",
    },
    {
      BuildingNumber: "52",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1Yi2AK",
    },
    {
      BuildingNumber: "53",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5ls2AC",
    },
    {
      BuildingNumber: "53",
      Street: "GESNER ST",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQO2AY",
    },
    {
      BuildingNumber: "54",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zjh2AA",
    },
    {
      BuildingNumber: "55",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A46h2AC",
    },
    {
      BuildingNumber: "56",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4GP2A0",
    },
    {
      BuildingNumber: "57",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xoS2AQ",
    },
    {
      BuildingNumber: "58",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Ri2AK",
    },
    {
      BuildingNumber: "59",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bT2AS",
    },
    {
      BuildingNumber: "60",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQR2AY",
    },
    {
      BuildingNumber: "61",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zex2AA",
    },
    {
      BuildingNumber: "62",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8712AC",
    },
    {
      BuildingNumber: "63",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xYN2AY",
    },
    {
      BuildingNumber: "64",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T62AK",
    },
    {
      BuildingNumber: "65",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2L22AK",
    },
    {
      BuildingNumber: "66",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4bU2AS",
    },
    {
      BuildingNumber: "67",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6TR2A0",
    },
    {
      BuildingNumber: "68",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ye92AA",
    },
    {
      BuildingNumber: "69",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwf2AA",
    },
    {
      BuildingNumber: "70",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7hC2AS",
    },
    {
      BuildingNumber: "71",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8er2AC",
    },
    {
      BuildingNumber: "72",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5PI2A0",
    },
    {
      BuildingNumber: "73",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zwe2AA",
    },
    {
      BuildingNumber: "74",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A21e2AC",
    },
    {
      BuildingNumber: "75",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0kh2AC",
    },
    {
      BuildingNumber: "76",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019ysW2AQ",
    },
    {
      BuildingNumber: "76",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Rz2AK",
    },
    {
      BuildingNumber: "77",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6gJ2AS",
    },
    {
      BuildingNumber: "77",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2T82AK",
    },
    {
      BuildingNumber: "78",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2eR2AS",
    },
    {
      BuildingNumber: "78",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7672AC",
    },
    {
      BuildingNumber: "79",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019v8L2AQ",
    },
    {
      BuildingNumber: "79",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1jx2AC",
    },
    {
      BuildingNumber: "80",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5652AC",
    },
    {
      BuildingNumber: "80",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5tv2AC",
    },
    {
      BuildingNumber: "81",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zS52AI",
    },
    {
      BuildingNumber: "81",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5KU2A0",
    },
    {
      BuildingNumber: "82",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Vf2AK",
    },
    {
      BuildingNumber: "82",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3PE2A0",
    },
    {
      BuildingNumber: "83",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5lt2AC",
    },
    {
      BuildingNumber: "83",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A0Hf2AK",
    },
    {
      BuildingNumber: "83",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4gF2AS",
    },
    {
      BuildingNumber: "84",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Q52AK",
    },
    {
      BuildingNumber: "84",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3Qv2AK",
    },
    {
      BuildingNumber: "85",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wDw2AI",
    },
    {
      BuildingNumber: "86",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2RT2A0",
    },
    {
      BuildingNumber: "86",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y62AK",
    },
    {
      BuildingNumber: "87",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5S2AQ",
    },
    {
      BuildingNumber: "87",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8Ok2AK",
    },
    {
      BuildingNumber: "87",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A6GW2A0",
    },
    {
      BuildingNumber: "88",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019vuh2AA",
    },
    {
      BuildingNumber: "88",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xQP2AY",
    },
    {
      BuildingNumber: "89",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019z5R2AQ",
    },
    {
      BuildingNumber: "89",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A5Z12AK",
    },
    {
      BuildingNumber: "90",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77i2AC",
    },
    {
      BuildingNumber: "90",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7CX2A0",
    },
    {
      BuildingNumber: "91",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A1dc2AC",
    },
    {
      BuildingNumber: "91",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019zQN2AY",
    },
    {
      BuildingNumber: "92",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A8VB2A0",
    },
    {
      BuildingNumber: "92",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A2g32AC",
    },
    {
      BuildingNumber: "93",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7Av2AK",
    },
    {
      BuildingNumber: "94",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wZ62AI",
    },
    {
      BuildingNumber: "94",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019x6p2AA",
    },
    {
      BuildingNumber: "95",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A77j2AC",
    },
    {
      BuildingNumber: "95",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4wL2AS",
    },
    {
      BuildingNumber: "96",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4Y42AK",
    },
    {
      BuildingNumber: "96",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019wu02AA",
    },
    {
      BuildingNumber: "97",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7UK2A0",
    },
    {
      BuildingNumber: "97",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A74U2AS",
    },
    {
      BuildingNumber: "98",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A4ef2AC",
    },
    {
      BuildingNumber: "98",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A7kS2AS",
    },
    {
      BuildingNumber: "99",
      Street: "ADELAIDE AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO0000019xOZ2AY",
    },
    {
      BuildingNumber: "99",
      Street: "CONVOY AVE",
      City: "Halifax",
      Province: "NS",
      SA_SFRecordID: "a2VOO000001A3kD2AS",
    },
  ]

export const holidayList = [
  {
    Date: "25/12/2024",
    Type: "Christmas Day",
    Weekday: "Wednesday",
  },
  {
    Date: "26/12/2024",
    Type: "Boxing Day",
    Weekday: "Thursday",
  },
  {
    Date: "01/01/2025",
    Type: "New Year's Day",
    Weekday: "Wednesday",
  },
  {
    Date: "18/04/2025",
    Type: "Good Friday",
    Weekday: "Friday",
  },
  {
    Date: "19/05/2025",
    Type: "Victoria Day",
    Weekday: "Monday",
  },
  {
    Date: "01/07/2025",
    Type: "Canada Day",
    Weekday: "Tuesday",
  },
  {
    Date: "04/08/2025",
    Type: "Natal Day",
    Weekday: "Monday",
  },
  {
    Date: "01/09/2025",
    Type: "Labour Day",
    Weekday: "Monday",
  },
  {
    Date: "30/09/2025",
    Type: "National Day for Truth and Reconciliation",
    Weekday: "Tuesday",
  },
  {
    Date: "13/10/2025",
    Type: "Thanksgiving Day",
    Weekday: "Monday",
  },
  {
    Date: "11/11/2025",
    Type: "Remembrance Day",
    Weekday: "Tuesday",
  },
  {
    Date: "25/12/2025",
    Type: "Christmas Day",
    Weekday: "Thursday",
  },
  {
    Date: "26/12/2025",
    Type: "Boxing Day",
    Weekday: "Friday",
  },
]
